var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _g3, _path18, _g4, _path19, _g5, _path20, _path21, _path22, _g6, _path23, _g7, _path24, _g8, _path25, _path26, _g9, _path27, _g0, _path28, _g1, _path29, _g10, _path30, _path31, _g11, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g12, _path56, _g13, _path57, _path58, _path59, _path60, _g14, _path61, _g15, _path62, _path63, _path64, _g16, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g17, _path81, _g18, _path82, _g19, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g20, _path109, _g21, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g22, _path126, _g23, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _g24, _path138, _g25, _path139, _g26, _path140, _g27, _path141, _g28, _path142, _g29, _path143, _g30, _path144, _g31, _path145, _path146, _path147, _g32, _path148, _path149, _path150, _g33, _path151, _g34, _path152, _g35, _path153, _g36, _path154, _g37, _path155, _g38, _path156, _path157, _g39, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _g40, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _g41, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _g42, _path223, _path224, _g43, _path225, _g44, _path226, _path227, _path228, _g45, _path229, _path230, _path231, _path232, _path233, _path234, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderLeftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 54,
    viewBox: "0 0 61 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 32,
    width: 61,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.489 53.8606C27.7422 53.8606 25.8985 53.437 24.4678 52.6111L3.02455 40.23C2.22052 39.766 1.63708 39.2268 1.2802 38.6644C1.0006 38.2239 0.860096 37.7694 0.86115 37.3254L0.859396 37.3247V34.4892C0.85483 35.5009 1.58861 36.5695 3.0242 37.3985L24.4678 49.7792C25.8985 50.6054 27.7426 51.029 29.4894 51.029C30.9351 51.029 32.3145 50.7392 33.3399 50.147L59.3277 35.1426C60.3537 34.55 60.856 33.7526 60.8553 32.9173V35.7362L60.8539 35.737C60.8567 36.181 60.7183 36.6141 60.4348 37.0121C60.1819 37.3668 59.8138 37.6935 59.3277 37.9745L33.3399 52.9782C32.3145 53.5708 30.9348 53.8606 29.489 53.8606Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.489 53.8606C27.7422 53.8606 25.8985 53.437 24.4678 52.6111L3.02455 40.23C2.22052 39.766 1.63708 39.2268 1.2802 38.6644C1.0006 38.2239 0.860096 37.7694 0.86115 37.3254L0.859396 37.3247V34.4892C0.85483 35.5009 1.58861 36.5695 3.0242 37.3985L24.4678 49.7792C25.8985 50.6054 27.7426 51.029 29.4894 51.029C30.9351 51.029 32.3145 50.7392 33.3399 50.147L59.3277 35.1426C60.3537 34.55 60.856 33.7526 60.8553 32.9173V35.7362L60.8539 35.737C60.8567 36.181 60.7183 36.6141 60.4348 37.0121C60.1819 37.3668 59.8138 37.6935 59.3277 37.9745L33.3399 52.9782C32.3145 53.5708 30.9348 53.8606 29.489 53.8606Z",
    fill: "#8F4300"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3826 17.2714L2.39514 32.2758C0.13023 33.5836 0.416857 35.8886 3.03197 37.3984L24.4756 49.7791C27.0903 51.2889 31.0831 51.4547 33.3476 50.1469L59.3354 35.1425C61.6 33.8347 61.3137 31.5297 58.6983 30.02L37.2547 17.6392C34.6399 16.1295 30.6472 15.9637 28.3826 17.2714Z",
    fill: "#C7A180"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.485 35.427L25.7814 35.2643L24.9293 35.9897L24.6328 36.1523L25.485 35.427Z",
    fill: "#57657D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8516 31.4398L23.148 31.2771L24.4881 32.0608L24.1916 32.2234L22.8516 31.4398Z",
    fill: "#62728C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1953 33.7461L25.4918 33.5838L25.7777 35.2643L25.4812 35.4269L25.1953 33.7461Z",
    fill: "#5D6C85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1953 32.2234L24.4918 32.0607L25.4971 33.5838L25.2006 33.7461L24.1953 32.2234Z",
    fill: "#62728C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9523 8.24695L25.2487 8.08432L24.0383 9.12583L23.7422 9.28847L24.9523 8.24695Z",
    fill: "#57657D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9219 7.60943L25.218 7.44715L25.2503 8.08435L24.9538 8.24698L24.9219 7.60943Z",
    fill: "#5C6A83"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 7.32458L24.9836 7.16195L25.2165 7.44719L24.9204 7.60947L24.6875 7.32458Z",
    fill: "#62728D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.8737 33.1353C17.8737 33.8807 16.7897 34.4852 15.4525 34.4852C14.1152 34.4852 13.0312 33.8807 13.0312 33.1353C13.0312 32.3899 14.1152 31.7854 15.4525 31.7854C16.7897 31.7854 17.8737 32.3899 17.8737 33.1353Z",
    fill: "#8F4300"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.5921 33.0886C20.5921 33.834 19.5081 34.4385 18.1709 34.4385C16.834 34.4385 15.75 33.834 15.75 33.0886C15.75 32.3432 16.834 31.739 18.1709 31.739C19.5081 31.739 20.5921 32.3432 20.5921 33.0886Z",
    fill: "#8F4300"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.2295 36.3547C27.1048 37.1995 25.4219 37.6509 23.4707 37.3625C21.5194 37.0744 20.0389 36.1562 20.1636 35.3114C20.2883 34.4666 21.9712 34.0152 23.9224 34.3033C25.8736 34.5917 27.3542 35.5099 27.2295 36.3547Z",
    fill: "#8F4300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4278 21.7378C14.5459 21.625 14.725 21.4729 14.6871 21.3479C14.6491 21.2228 14.5494 21.0925 14.5121 20.9618C14.4753 20.8312 14.5624 20.4746 14.3506 20.4616C14.1384 20.4486 13.8174 20.717 13.8174 20.717C13.8174 20.717 13.6596 21.3437 13.7791 21.3999C13.8988 21.4564 14.4278 21.7378 14.4278 21.7378Z",
    fill: "#FF8964"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.658 31.4008C14.658 31.4008 14.3478 31.7106 14.1202 31.9105C13.8926 32.1104 13.1855 32.6387 13.1019 32.7799C13.0183 32.9214 13.0341 33.1652 13.0313 33.2341C13.0285 33.3033 13.2073 33.6974 13.7271 33.6278C14.1054 33.5765 14.8497 32.8793 14.8729 32.8526C15.0373 32.6622 15.2224 32.4862 15.344 32.4511C15.4648 32.4156 16.0222 32.1571 16.0732 31.8796C16.1238 31.6021 16.0971 31.1658 16.0391 31.0738C15.8213 30.7295 14.658 31.4008 14.658 31.4008Z",
    fill: "#1C2134"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8496 31.4759C16.1755 31.588 16.1675 31.7643 16.1945 31.8647C16.2212 31.9652 16.1797 32.2568 16.1703 32.3168C16.1611 32.3772 15.5559 32.7735 15.4182 32.7907C15.2805 32.8079 15.0473 32.8753 14.9928 32.9516C14.9388 33.0281 14.8594 33.2076 14.381 33.5031C13.9419 33.7746 13.6384 33.8656 13.3173 33.7511C12.9963 33.6365 12.9685 33.4542 12.9731 33.378C12.978 33.3014 12.9404 33.1543 13.023 32.9934C13.1059 32.8328 13.9696 32.2606 13.9696 32.2606L15.8496 31.4759Z",
    fill: "#1C2134"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5739 31.7166C18.5739 31.7166 18.5612 32.1546 18.4685 32.6692C18.399 33.0542 18.2244 33.2587 18.1791 33.4469C18.1341 33.6352 18.105 33.9299 18.1738 34.0121C18.3287 34.1972 18.981 34.2938 19.3291 33.9714C19.6775 33.6489 19.7685 33.3205 19.8107 33.122C19.8525 32.9242 19.9382 32.6963 20.0225 32.4929C20.1064 32.2899 20.1184 32.0285 20.1184 32.0285C20.1184 32.0285 20.0945 31.4623 19.9909 31.2775C19.8872 31.0927 18.5739 31.7166 18.5739 31.7166Z",
    fill: "#1C2134"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1741 31.9923C20.1854 31.9941 20.1776 32.2969 20.1752 32.47C20.1727 32.6432 20.0055 32.9987 19.9539 33.1722C19.9388 33.2232 19.9058 33.2383 19.9008 33.259C19.8604 33.4353 19.8836 33.5516 19.7684 33.7557C19.6051 34.0455 19.3936 34.4059 18.8861 34.4343C18.3785 34.4631 18.2169 34.3374 18.1505 34.2302C18.0841 34.1238 18.0877 33.9422 18.1031 33.7206C18.1161 33.5326 19.5847 32.1771 19.9736 31.843C20.0435 31.783 20.1741 31.9923 20.1741 31.9923Z",
    fill: "#1C2134"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 25,
    width: 3,
    height: 8
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9299 26.4174C17.9299 26.4174 17.5558 25.9154 17.7686 27.1849C17.9899 28.5025 18.3752 31.5979 18.4732 31.8898C18.5705 32.1817 19.2218 32.208 19.5038 32.0869C19.7856 31.9657 19.8751 31.6042 19.9001 31.3766C19.9243 31.149 19.9503 29.1109 19.8354 27.9247C19.7206 26.7385 19.1965 25.5055 19.1965 25.5055L17.9299 26.4174Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9299 26.4174C17.9299 26.4174 17.5558 25.9154 17.7686 27.1849C17.9899 28.5025 18.3752 31.5979 18.4732 31.8898C18.5705 32.1817 19.2218 32.208 19.5038 32.0869C19.7856 31.9657 19.8751 31.6042 19.9001 31.3766C19.9243 31.149 19.9503 29.1109 19.8354 27.9247C19.7206 26.7385 19.1965 25.5055 19.1965 25.5055L17.9299 26.4174Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 26,
    width: 3,
    height: 6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4383 26.8725C14.323 28.6099 14.4962 31.1724 14.479 31.4696C14.472 31.5858 14.5749 31.7499 14.7484 31.8163C15.0168 31.9192 15.4186 31.8865 15.5693 31.8384C16.1991 31.6371 16.0948 31.3761 16.0997 31.1369C16.1029 30.976 16.327 29.0567 16.3375 28.0286C16.348 27.0007 16.2883 26.0439 16.2883 26.0439L14.4383 26.8725Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4383 26.8725C14.323 28.6099 14.4962 31.1724 14.479 31.4696C14.472 31.5858 14.5749 31.7499 14.7484 31.8163C15.0168 31.9192 15.4186 31.8865 15.5693 31.8384C16.1991 31.6371 16.0948 31.3761 16.0997 31.1369C16.1029 30.976 16.327 29.0567 16.3375 28.0286C16.348 27.0007 16.2883 26.0439 16.2883 26.0439L14.4383 26.8725Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 2,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9423 14.6733C13.7843 15.2905 13.8225 15.5694 13.7449 15.9874C13.6676 16.4051 13.5893 16.8055 13.6269 16.964C13.6645 17.122 14.543 16.8849 14.7017 16.331C14.8602 15.7767 14.9441 15.0899 14.9958 14.8304C15.0477 14.5711 13.9423 14.6733 13.9423 14.6733Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9423 14.6733C13.7843 15.2905 13.8225 15.5694 13.7449 15.9874C13.6676 16.4051 13.5893 16.8055 13.6269 16.964C13.6645 17.122 14.543 16.8849 14.7017 16.331C14.8602 15.7767 14.9441 15.0899 14.9958 14.8304C15.0477 14.5711 13.9423 14.6733 13.9423 14.6733Z",
    fill: "url(#paint0_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 16,
    width: 2,
    height: 6
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0351 16.6682C13.9147 16.7588 13.6287 16.5508 13.6488 16.9941C13.6695 17.4374 14.0875 19.5173 14.0587 19.8134C14.0302 20.1095 13.5866 20.5535 13.5718 20.7127C13.5567 20.8725 13.6579 21.548 13.6899 21.5929C13.7215 21.6379 14.2132 21.7493 14.3639 21.7693C14.5143 21.7893 14.4268 21.6242 14.4268 21.6242L14.3811 21.4696L13.9343 21.3267C13.9343 21.3267 13.9487 20.8778 13.9628 20.83C13.9772 20.7822 14.4493 20.8093 14.5143 20.6385C14.5792 20.4675 14.5852 19.9697 14.5922 19.8443C14.5996 19.7186 14.6867 16.8491 14.5645 16.6987C14.4423 16.5487 14.0351 16.6682 14.0351 16.6682Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0351 16.6682C13.9147 16.7588 13.6287 16.5508 13.6488 16.9941C13.6695 17.4374 14.0875 19.5173 14.0587 19.8134C14.0302 20.1095 13.5866 20.5535 13.5718 20.7127C13.5567 20.8725 13.6579 21.548 13.6899 21.5929C13.7215 21.6379 14.2132 21.7493 14.3639 21.7693C14.5143 21.7893 14.4268 21.6242 14.4268 21.6242L14.3811 21.4696L13.9343 21.3267C13.9343 21.3267 13.9487 20.8778 13.9628 20.83C13.9772 20.7822 14.4493 20.8093 14.5143 20.6385C14.5792 20.4675 14.5852 19.9697 14.5922 19.8443C14.5996 19.7186 14.6867 16.8491 14.5645 16.6987C14.4423 16.5487 14.0351 16.6682 14.0351 16.6682Z",
    fill: "url(#paint1_linear_3227_19821)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0736 12.7657C15.297 12.3326 14.4286 12.85 14.1269 13.6551C13.9278 14.1869 13.7174 15.3573 13.7188 15.5354C13.7198 15.7135 14.7508 16.1656 15.0693 15.6464C15.2042 15.4269 16.0736 12.7657 16.0736 12.7657Z",
    fill: "#C7A180"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.968 12.7141C18.143 12.9884 19.3225 13.5912 19.4138 13.7261C19.5055 13.8613 19.3678 15.5787 19.2108 16.5773C19.0538 17.576 19.0257 19.3839 18.9526 19.9906C18.8792 20.5969 17.7088 21.2435 16.0382 20.7461C14.8285 20.3857 14.7319 19.8813 14.7179 19.7278C14.7038 19.5743 14.5556 16.8344 14.4312 16.4758C14.3069 16.1175 14.4878 14.1437 14.7077 13.6463C15.0565 12.8574 15.603 12.8303 15.8096 12.8489C16.0161 12.8676 16.968 12.7141 16.968 12.7141Z",
    fill: "#C7A180"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 12,
    width: 3,
    height: 6
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0367 12.8392C15.376 13.3437 15.1866 13.781 15.0574 15.5767C14.9285 17.3724 14.9994 17.7103 14.9994 17.7103C14.9994 17.7103 14.7813 17.5842 14.6025 17.4809C14.4234 17.3776 14.5421 15.6617 14.6046 14.9005C14.6675 14.1393 14.8881 13.4382 15.1424 13.108C15.3967 12.7778 16.0367 12.8392 16.0367 12.8392Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0367 12.8392C15.376 13.3437 15.1866 13.781 15.0574 15.5767C14.9285 17.3724 14.9994 17.7103 14.9994 17.7103C14.9994 17.7103 14.7813 17.5842 14.6025 17.4809C14.4234 17.3776 14.5421 15.6617 14.6046 14.9005C14.6675 14.1393 14.8881 13.4382 15.1424 13.108C15.3967 12.7778 16.0367 12.8392 16.0367 12.8392Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 15,
    width: 5,
    height: 4
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9922 16.5223C21.3407 17.4251 22.3488 18.2161 22.7158 18.3366C23.0829 18.4571 23.1876 17.4412 22.8483 17.104C22.5086 16.7672 21.2325 15.7313 20.9399 15.5082C20.6476 15.2852 19.9922 16.5223 19.9922 16.5223Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9922 16.5223C21.3407 17.4251 22.3488 18.2161 22.7158 18.3366C23.0829 18.4571 23.1876 17.4412 22.8483 17.104C22.5086 16.7672 21.2325 15.7313 20.9399 15.5082C20.6476 15.2852 19.9922 16.5223 19.9922 16.5223Z",
    fill: "url(#paint2_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 16,
    width: 1,
    height: 1
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2607 16.4286C24.2607 16.4286 24.3907 16.4834 24.5171 16.5024C24.6436 16.521 24.8143 16.684 24.8389 16.7342C24.8631 16.7841 24.8076 16.8526 24.7493 16.8719C24.6907 16.8916 24.5473 16.8747 24.4725 16.8561C24.3977 16.8375 24.2344 16.7493 24.2344 16.7493L24.2607 16.4286Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2607 16.4286C24.2607 16.4286 24.3907 16.4834 24.5171 16.5024C24.6436 16.521 24.8143 16.684 24.8389 16.7342C24.8631 16.7841 24.8076 16.8526 24.7493 16.8719C24.6907 16.8916 24.5473 16.8747 24.4725 16.8561C24.3977 16.8375 24.2344 16.7493 24.2344 16.7493L24.2607 16.4286Z",
    fill: "url(#paint3_linear_3227_19821)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5377 21.1992C14.5546 21.3489 14.4615 21.4293 14.3719 21.39C14.2827 21.3503 14.2381 21.2277 14.2588 21.1202C14.2792 21.0124 14.2637 20.8673 14.2427 20.7735C14.2212 20.6797 14.0842 20.672 14.151 20.4068C14.2181 20.1412 14.4907 20.1974 14.5483 20.3523C14.6062 20.5072 14.55 20.8448 14.5581 20.9228C14.5665 21.0004 14.5377 21.1992 14.5377 21.1992Z",
    fill: "#FF9574"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 19,
    width: 3,
    height: 9
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7979 19.2236C14.7979 19.2236 14.4038 21.8451 14.3831 22.9948C14.3627 24.1445 14.3778 26.7583 14.4652 27.0993C14.5524 27.4401 15.3511 27.4864 15.6202 27.3263C15.8889 27.1661 16.2128 26.9827 16.3118 26.6799C16.4105 26.3771 16.6648 23.4149 16.7442 22.9614C16.8243 22.5079 16.8717 21.2525 16.7825 20.4228C16.6929 19.5927 14.7979 19.2236 14.7979 19.2236Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7979 19.2236C14.7979 19.2236 14.4038 21.8451 14.3831 22.9948C14.3627 24.1445 14.3778 26.7583 14.4652 27.0993C14.5524 27.4401 15.3511 27.4864 15.6202 27.3263C15.8889 27.1661 16.2128 26.9827 16.3118 26.6799C16.4105 26.3771 16.6648 23.4149 16.7442 22.9614C16.8243 22.5079 16.8717 21.2525 16.7825 20.4228C16.6929 19.5927 14.7979 19.2236 14.7979 19.2236Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 19,
    width: 5,
    height: 9
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0422 20.3953C16.0422 20.3953 15.8904 22.6234 16.0232 22.9669C16.1563 23.3108 16.8125 23.3178 16.8125 23.3178C16.8125 23.3178 17.6576 27.0553 17.854 27.4217C18.0503 27.7881 18.729 27.7354 19.0184 27.4888C19.3071 27.2422 19.4863 26.7371 19.448 26.5973C19.4097 26.4575 19.5091 22.8896 19.4016 22.1738C19.2941 21.4572 18.8554 19.737 18.7406 19.547C18.6253 19.3573 16.0422 20.3953 16.0422 20.3953Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0422 20.3953C16.0422 20.3953 15.8904 22.6234 16.0232 22.9669C16.1563 23.3108 16.8125 23.3178 16.8125 23.3178C16.8125 23.3178 17.6576 27.0553 17.854 27.4217C18.0503 27.7881 18.729 27.7354 19.0184 27.4888C19.3071 27.2422 19.4863 26.7371 19.448 26.5973C19.4097 26.4575 19.5091 22.8896 19.4016 22.1738C19.2941 21.4572 18.8554 19.737 18.7406 19.547C18.6253 19.3573 16.0422 20.3953 16.0422 20.3953Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 10,
    width: 3,
    height: 5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8339 13.8979C16.3229 14.09 16.7072 14.116 17.0556 13.8996C17.4041 13.6829 17.8375 13.0935 17.6475 12.8897C17.4578 12.686 17.3507 12.5536 17.3717 12.1236C17.3928 11.6937 17.7599 11.4207 17.729 10.9609C17.6984 10.5011 17.3046 10.0508 16.7061 10.2984C16.1079 10.5464 15.2986 11.6048 15.534 12.2827C15.7697 12.9607 15.685 13.4395 15.6818 13.5884C15.679 13.737 15.8339 13.8979 15.8339 13.8979Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8339 13.8979C16.3229 14.09 16.7072 14.116 17.0556 13.8996C17.4041 13.6829 17.8375 13.0935 17.6475 12.8897C17.4578 12.686 17.3507 12.5536 17.3717 12.1236C17.3928 11.6937 17.7599 11.4207 17.729 10.9609C17.6984 10.5011 17.3046 10.0508 16.7061 10.2984C16.1079 10.5464 15.2986 11.6048 15.534 12.2827C15.7697 12.9607 15.685 13.4395 15.6818 13.5884C15.679 13.737 15.8339 13.8979 15.8339 13.8979Z",
    fill: "url(#paint4_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 4,
    height: 5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1744 9.6295C15.1744 9.6295 14.9918 9.74893 14.9293 10.4325C14.8671 11.1161 14.9925 12.3722 15.3652 13.0688C15.4112 13.1548 15.7709 13.27 15.8935 13.2697C16.0153 13.269 16.9725 12.5967 17.0663 12.4263C17.1604 12.2563 17.1794 10.7377 17.1302 10.3991C17.0811 10.0605 17.1822 9.76087 16.5823 9.57365C15.9823 9.38607 15.1744 9.6295 15.1744 9.6295Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1744 9.6295C15.1744 9.6295 14.9918 9.74893 14.9293 10.4325C14.8671 11.1161 14.9925 12.3722 15.3652 13.0688C15.4112 13.1548 15.7709 13.27 15.8935 13.2697C16.0153 13.269 16.9725 12.5967 17.0663 12.4263C17.1604 12.2563 17.1794 10.7377 17.1302 10.3991C17.0811 10.0605 17.1822 9.76087 16.5823 9.57365C15.9823 9.38607 15.1744 9.6295 15.1744 9.6295Z",
    fill: "url(#paint5_linear_3227_19821)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2821 10.0419C16.3527 10.4684 16.5512 10.1979 16.5585 10.336C16.5659 10.4737 16.58 10.7571 16.58 10.7571C16.58 10.7571 16.8673 11.0715 16.8936 11.2791C16.9196 11.4867 16.927 11.7038 16.927 11.7038L17.1627 11.6479C17.1627 11.6479 17.0984 11.2984 17.345 11.1295C17.5912 10.9605 17.652 11.2313 17.6239 11.3213C17.5958 11.4112 17.3917 11.7737 17.3917 11.7737C17.3917 11.7737 17.3534 12.0385 17.3713 12.1236C17.5691 11.7382 17.7714 11.5622 17.913 10.8962C18.0549 10.2299 18.1831 9.4771 17.2287 9.17572C16.4851 8.56802 15.4738 8.55467 15.0868 9.07208C14.9803 9.2147 14.8746 9.52874 14.9754 9.86841C14.942 10.069 14.8971 10.3426 14.9206 10.5853C15.0267 10.0261 15.0481 9.93972 15.0885 9.87684C15.1026 9.85471 15.0994 9.96887 15.2821 10.0419Z",
    fill: "#553012"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 10,
    width: 1,
    height: 2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2331 11.3419C17.2223 11.089 17.3628 11.0033 17.4804 10.9994C17.5981 10.9956 17.6381 11.1719 17.551 11.3862C17.4643 11.6005 17.5103 11.826 17.3691 11.8312C17.2275 11.8369 17.2156 11.7715 17.2324 11.6739C17.2493 11.5759 17.2331 11.3419 17.2331 11.3419Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2331 11.3419C17.2223 11.089 17.3628 11.0033 17.4804 10.9994C17.5981 10.9956 17.6381 11.1719 17.551 11.3862C17.4643 11.6005 17.5103 11.826 17.3691 11.8312C17.2275 11.8369 17.2156 11.7715 17.2324 11.6739C17.2493 11.5759 17.2331 11.3419 17.2331 11.3419Z",
    fill: "url(#paint6_linear_3227_19821)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1297 13.6424C18.8919 13.7734 18.3566 14.1626 18.4191 14.9621C18.4816 15.7616 18.6678 15.9752 18.769 16.1118C18.8698 16.2484 20.0356 16.8807 20.0356 16.8807C20.0356 16.8807 20.4989 16.8438 20.7153 16.6549C21.181 16.2477 21.1954 15.6899 21.063 15.4212C20.9478 15.188 19.7166 13.916 19.4191 13.726C19.3018 13.6354 19.2172 13.5943 19.1297 13.6424Z",
    fill: "#C7A180"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2734 36.5879L24.0845 36.1593L24.6131 36.1713L23.8024 36.5998L23.2734 36.5879Z",
    fill: "#546683"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0526 31.8711L22.8633 31.4426L21.6388 32.4925L20.8281 32.9214L22.0526 31.8711Z",
    fill: "#4F607C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 32.7942L23.1232 32.3657L23.9114 32.8417L23.1004 33.2706L22.3125 32.7942Z",
    fill: "#586B8B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1016 33.2706L23.9126 32.8417L24.5888 33.8909L23.7777 34.3195L23.1016 33.2706Z",
    fill: "#596C8C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7812 34.3194L24.5923 33.8909L24.7609 34.8983L23.9499 35.3269L23.7812 34.3194Z",
    fill: "#556785"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6414 35.8829L25.4524 35.4544L24.6154 36.1713L23.8047 36.5998L24.6414 35.8829Z",
    fill: "#57657D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0547 31.8711L22.8654 31.4426L24.1819 32.2382L23.3712 32.6667L22.0547 31.8711Z",
    fill: "#62728C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3672 32.6667L24.1779 32.2381L25.1663 33.7707L24.3553 34.1992L23.3672 32.6667Z",
    fill: "#62728D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3594 34.1993L25.1704 33.7708L25.4521 35.4544L24.6411 35.883L24.3594 34.1993Z",
    fill: "#5E6D86"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9922 30.4818L22.8032 30.0533L24.7882 30.8879L23.9771 31.3164L21.9922 30.4818Z",
    fill: "#576A89"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1891 31.0537L24.9998 30.6251L24.7876 30.8879L23.9766 31.3164L24.1891 31.0537Z",
    fill: "#4A5D7C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1865 31.0537L24.4092 31.3822L25.3875 33.6619L25.4792 35.5022L24.6709 36.6203L23.2711 36.5879L23.8001 36.5999L24.6368 35.8829L24.3551 34.1993L23.367 32.6667L22.0505 31.8711L20.826 32.9214L20.8577 33.559L20.7656 31.7187L21.5535 30.1815L21.7516 30.0298L21.9891 30.4818L23.974 31.3165L24.1865 31.0537Z",
    fill: "#9CBEF5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8281 32.9214L21.6388 32.4925L21.6708 33.1307L20.8597 33.5589L20.8281 32.9214Z",
    fill: "#536583"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9453 36.183L23.756 35.7544L24.0795 36.1594L23.2685 36.588L22.9453 36.183Z",
    fill: "#596D8C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 30.0297L22.5611 29.6015L22.7985 30.0533L21.9875 30.4818L21.75 30.0297Z",
    fill: "#586B8B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0385 32.9456L22.7491 32.7629L22.1639 33.261L20.7891 34.0089L22.0385 32.9456Z",
    fill: "#57657D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4068 36.0132L24.7033 35.8506L23.8511 36.5749L23.5547 36.7375L24.4068 36.0132Z",
    fill: "#57657D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7734 32.0249L22.0695 31.8623L23.4099 32.646L23.1135 32.8086L21.7734 32.0249Z",
    fill: "#62728C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1172 34.3321L24.4137 34.1698L24.6996 35.8506L24.4031 36.0132L24.1172 34.3321Z",
    fill: "#5D6C85"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1172 32.8086L23.4136 32.646L24.419 34.1698L24.1225 34.3321L23.1172 32.8086Z",
    fill: "#62728C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7704 32.0249L23.1104 32.8086L24.1157 34.332L24.4017 36.0132L23.5495 36.7375L23.0114 36.7305L22.6823 36.3283L23.6988 35.4631L23.5277 34.4574L22.8396 33.4145L22.0377 32.9456L20.7883 34.0089L20.5554 33.724L20.5234 33.0864L21.7704 32.0249Z",
    fill: "#ADC8F7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4801 35.5022L26.2912 35.0736L25.4826 36.1914L24.6719 36.6203L25.4801 35.5022Z",
    fill: "#4F607C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 29,
    width: 3,
    height: 2
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0282 29.8518L23.2175 30.2807C23.1473 30.3179 23.0577 30.32 22.9583 30.2778C22.7156 30.176 22.5069 29.8521 22.4922 29.5546L23.3029 29.1257C23.318 29.4236 23.5266 29.7474 23.7694 29.8493C23.8684 29.8911 23.958 29.8893 24.0282 29.8518Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4922 29.5547L23.3029 29.1258C23.3106 29.2786 23.3689 29.4377 23.4567 29.5705L22.646 29.9991C22.5582 29.8666 22.4996 29.7068 22.4922 29.5547Z",
    fill: "#5D6C85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6484 29.9991L23.4591 29.5706C23.5427 29.697 23.653 29.7996 23.7718 29.8495L23.8027 29.8611L22.992 30.29L22.9607 30.278C22.8423 30.2285 22.732 30.1259 22.6484 29.9991Z",
    fill: "#5D6C85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9922 30.2899L23.8029 29.861C23.8897 29.8905 23.968 29.8852 24.0309 29.8522L23.2202 30.2808C23.1573 30.3141 23.0789 30.3194 22.9922 30.2899Z",
    fill: "#5D6C85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 29,
    width: 2,
    height: 2
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0373 29.852L23.2266 30.2809C23.3277 30.2276 23.3885 30.1004 23.3801 29.9244L24.1908 29.4959C24.1995 29.6715 24.1388 29.7987 24.0373 29.852Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3801 29.9244L24.1908 29.4959C24.1995 29.6715 24.1388 29.7987 24.0373 29.8524L23.2266 30.2809C23.3277 30.2276 23.3885 30.1004 23.3801 29.9244Z",
    fill: "#42597F"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3906 33.6619L26.2013 33.2334L26.2934 35.0736L25.4823 35.5022L25.3906 33.6619Z",
    fill: "#536583"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 11.7158L22.4126 11.2869L23.3034 29.126L22.4927 29.5549L21.6016 11.7158Z",
    fill: "#5D6C85"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9931 10.2801L21.8041 9.85158L21.5923 10.115L20.7812 10.5436L20.9931 10.2801Z",
    fill: "#4F607C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 10,
    width: 2,
    height: 2
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5513 10.9303C22.4498 10.9841 22.3891 11.1112 22.3978 11.2869L21.5868 11.7158C21.578 11.5401 21.6388 11.4126 21.7403 11.3592C21.9834 11.2307 22.3079 11.0592 22.5513 10.9303Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7403 11.3592L22.5513 10.9303C22.4498 10.9841 22.3891 11.1112 22.3978 11.2869L21.5868 11.7158C21.578 11.5401 21.6388 11.4126 21.7403 11.3592Z",
    fill: "#5D6C85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 10,
    width: 2,
    height: 2
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7734 11.3591L22.5845 10.9302C22.6544 10.893 22.7443 10.8913 22.8434 10.9331L22.0323 11.362C21.9333 11.3202 21.8437 11.3219 21.7734 11.3591Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7734 11.3591L22.5845 10.9302C22.647 10.8972 22.7253 10.8919 22.8125 10.9215L22.0014 11.3503C21.9146 11.3208 21.8363 11.3258 21.7734 11.3591Z",
    fill: "#42597F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.3504L22.8111 10.9215L22.842 10.9331L22.0309 11.362L22 11.3504Z",
    fill: "#455C84"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4766 12.0853L23.2876 11.6567L24.1784 29.4959L23.3677 29.9244L22.4766 12.0853Z",
    fill: "#435B82"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2726 11.2113C22.5153 11.3132 22.7243 11.6371 22.739 11.9346L23.6302 29.7737C23.6449 30.0716 23.4602 30.2296 23.2175 30.1278C22.9747 30.0256 22.7661 29.702 22.751 29.4042L21.8602 11.565C21.8454 11.2675 22.0299 11.1091 22.2726 11.2113Z",
    fill: "#7EAAF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 10,
    width: 2,
    height: 3
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0078 11.3619L22.8189 10.933C23.0616 11.0352 23.2706 11.3591 23.2853 11.6566L22.4743 12.0852C22.4595 11.7876 22.2509 11.4638 22.0078 11.3619Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0078 11.3619L22.8189 10.933C22.9372 10.9829 23.0479 11.0855 23.1315 11.2123L22.3204 11.6408C22.2368 11.5144 22.1265 11.4114 22.0078 11.3619Z",
    fill: "#455C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3203 11.6408L23.1314 11.2123C23.2192 11.3447 23.2775 11.5042 23.2852 11.6566L22.4742 12.0852C22.4664 11.9327 22.4081 11.7736 22.3203 11.6408Z",
    fill: "#42597F"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3718 29.9244L22.4806 12.0852C22.4659 11.7877 22.2572 11.4638 22.0142 11.362C21.7714 11.2598 21.587 11.4182 21.6018 11.7157L22.4929 29.5548C22.5077 29.8524 22.7163 30.1762 22.959 30.2781C23.2018 30.3803 23.3865 30.2219 23.3718 29.9244ZM22.9791 11.1147L23.2162 11.5671L24.1895 31.0537L23.977 31.3164L21.992 30.4818L21.7546 30.0297L20.7812 10.5428L20.9938 10.2801L22.9791 11.1147Z",
    fill: "#93B8F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1875 31.0537L24.9982 30.6252L25.2212 30.9533L24.4102 31.3822L24.1875 31.0537Z",
    fill: "#596C8C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4141 31.3822L25.2251 30.9533L26.203 33.2334L25.3923 33.6619L24.4141 31.3822Z",
    fill: "#586A8A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2109 11.5671L24.022 11.1386L24.995 30.6252L24.1843 31.0537L23.2109 11.5671Z",
    fill: "#4E6283"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9766 11.1146L23.7873 10.6861L24.0247 11.1385L23.2137 11.5671L22.9766 11.1146Z",
    fill: "#53688B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9922 10.2801L21.8032 9.85156L23.7882 10.6862L22.9775 11.1147L20.9922 10.2801Z",
    fill: "#526789"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4098 11.416L24.2208 10.9871L24.022 11.1385L23.2109 11.5671L23.4098 11.416Z",
    fill: "#4F607C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2016 9.87862L25.0123 9.44972L24.2251 10.9872L23.4141 11.4161L24.2016 9.87862Z",
    fill: "#4F607C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 4.99742L21.9826 4.56853L22.5119 4.58012L21.7009 5.00867L21.1719 4.99742Z",
    fill: "#5D6C85"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2969 4.97741L21.1079 4.54851L22.5073 4.58012L21.6963 5.00867L20.2969 4.97741Z",
    fill: "#546683"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1386 8.67519L24.9493 8.24664L23.7251 9.29764L22.9141 9.72653L24.1386 8.67519Z",
    fill: "#57657D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1406 8.67519L24.9513 8.24663L25.0114 9.44973L24.2007 9.87863L24.1406 8.67519Z",
    fill: "#536583"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6924 5.00856L21.1634 4.99732L20.327 5.71461L20.6088 7.39788L21.5968 8.93047L22.9133 9.72644L24.1378 8.6751L24.1979 9.87854L23.4104 11.416L23.2116 11.5671L22.9745 11.1146L20.9892 10.28L20.7774 10.5435L20.5547 10.2154L19.5764 7.93568L19.4844 6.09503L20.293 4.9773L21.6924 5.00856Z",
    fill: "#9CBEF5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 8.03823L24.9204 7.60933L24.952 8.24653L24.1413 8.67508L24.1094 8.03823Z",
    fill: "#5C6B84"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8828 7.75136L24.6935 7.32247L24.9225 7.60945L24.1115 8.03835L23.8828 7.75136Z",
    fill: "#63738E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 16,
    width: 2,
    height: 3
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3269 16.9482L24.3224 17.0283C24.3224 17.0283 23.8422 17.0195 23.7899 16.9974C23.7375 16.9753 23.7115 17.1611 23.7554 17.1941C23.7993 17.2271 23.8503 17.2721 23.8503 17.2721C23.8503 17.2721 23.5208 17.2299 23.4811 17.2507C23.4418 17.2714 23.4245 17.3736 23.4484 17.4207C23.4727 17.4677 23.4906 17.4843 23.4906 17.4843C23.4906 17.4843 23.4326 17.6297 23.5201 17.7035C23.6076 17.7772 23.7228 17.7646 23.7228 17.7646C23.7228 17.7646 23.656 17.8562 23.7294 17.9788C23.8025 18.1014 23.9999 18.2504 24.0898 18.2785C24.1798 18.3066 24.5426 18.3045 24.6223 18.2479C24.7017 18.1917 24.6652 18.0329 24.6652 18.0329C24.6652 18.0329 24.7857 17.9328 24.8018 17.8499C24.818 17.767 24.8106 17.694 24.8106 17.694C24.8106 17.694 24.91 17.6961 24.9132 17.5053C24.9167 17.3146 24.8819 17.3202 24.8819 17.3202C24.8819 17.3202 24.9574 17.1376 24.9237 17.0592C24.89 16.9809 24.7021 16.8671 24.7021 16.8671L24.3157 16.7266L24.3269 16.9482Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3269 16.9482L24.3224 17.0283C24.3224 17.0283 23.8422 17.0195 23.7899 16.9974C23.7375 16.9753 23.7115 17.1611 23.7554 17.1941C23.7993 17.2271 23.8503 17.2721 23.8503 17.2721C23.8503 17.2721 23.5208 17.2299 23.4811 17.2507C23.4418 17.2714 23.4245 17.3736 23.4484 17.4207C23.4727 17.4677 23.4906 17.4843 23.4906 17.4843C23.4906 17.4843 23.4326 17.6297 23.5201 17.7035C23.6076 17.7772 23.7228 17.7646 23.7228 17.7646C23.7228 17.7646 23.656 17.8562 23.7294 17.9788C23.8025 18.1014 23.9999 18.2504 24.0898 18.2785C24.1798 18.3066 24.5426 18.3045 24.6223 18.2479C24.7017 18.1917 24.6652 18.0329 24.6652 18.0329C24.6652 18.0329 24.7857 17.9328 24.8018 17.8499C24.818 17.767 24.8106 17.694 24.8106 17.694C24.8106 17.694 24.91 17.6961 24.9132 17.5053C24.9167 17.3146 24.8819 17.3202 24.8819 17.3202C24.8819 17.3202 24.9574 17.1376 24.9237 17.0592C24.89 16.9809 24.7021 16.8671 24.7021 16.8671L24.3157 16.7266L24.3269 16.9482Z",
    fill: "url(#paint7_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 13,
    width: 3,
    height: 6
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8722 13.3947C18.3078 13.4723 17.8276 13.9869 17.6425 15.4229C17.4577 16.8592 17.5891 18.3764 17.5891 18.3764L16.9062 17.9822C16.9062 17.9822 16.9235 15.4809 17.0468 14.8795C17.1697 14.2778 17.4816 13.6286 17.75 13.3947C18.018 13.1607 18.3253 13.1513 18.3253 13.1513L18.8722 13.3947Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8722 13.3947C18.3078 13.4723 17.8276 13.9869 17.6425 15.4229C17.4577 16.8592 17.5891 18.3764 17.5891 18.3764L16.9062 17.9822C16.9062 17.9822 16.9235 15.4809 17.0468 14.8795C17.1697 14.2778 17.4816 13.6286 17.75 13.3947C18.018 13.1607 18.3253 13.1513 18.3253 13.1513L18.8722 13.3947Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 6,
    height: 7
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1725 16.9442C19.0597 17.5972 18.4875 18.0247 18.0038 17.6949C17.7165 17.4989 17.7404 16.8996 17.4541 16.7264C17.1678 16.5533 16.3975 16.5122 15.5823 16.1388C14.767 15.7657 14.7835 15.7281 14.7835 15.7281C14.7835 15.7281 14.4375 16.1602 14.4375 16.4286C14.4375 16.6969 14.5527 17.5825 14.5812 18.1916C14.6093 18.8007 14.6261 19.9353 14.6275 20.3427C14.6289 20.7506 15.5949 21.1784 16.5447 21.4538C17.4941 21.7292 19.0186 21.5339 19.0186 20.3768C19.0186 19.2197 19.1725 16.9442 19.1725 16.9442Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1725 16.9442C19.0597 17.5972 18.4875 18.0247 18.0038 17.6949C17.7165 17.4989 17.7404 16.8996 17.4541 16.7264C17.1678 16.5533 16.3975 16.5122 15.5823 16.1388C14.767 15.7657 14.7835 15.7281 14.7835 15.7281C14.7835 15.7281 14.4375 16.1602 14.4375 16.4286C14.4375 16.6969 14.5527 17.5825 14.5812 18.1916C14.6093 18.8007 14.6261 19.9353 14.6275 20.3427C14.6289 20.7506 15.5949 21.1784 16.5447 21.4538C17.4941 21.7292 19.0186 21.5339 19.0186 20.3768C19.0186 19.2197 19.1725 16.9442 19.1725 16.9442Z",
    fill: "#8F4300"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4435 12.6262C17.4646 12.6666 17.3381 13.0382 17.0473 13.3263C16.7565 13.6143 16.212 13.7151 15.9781 13.7014C15.9507 13.7394 15.9219 13.9357 15.9219 13.9357L16.0136 14.3565C16.0136 14.3565 16.3887 14.3811 16.9079 14.1391C17.427 13.8971 17.753 13.2413 17.7748 13.1222C17.7965 13.0027 17.7748 12.9592 17.7748 12.9592C17.7748 12.9592 17.5303 12.4892 17.4758 12.4291C17.4217 12.3694 17.3789 12.3922 17.3789 12.3922C17.3789 12.3922 17.3915 12.5282 17.4435 12.6262Z",
    fill: "#C7A180"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9772 13.7014C15.9772 13.7014 15.8019 13.647 15.7524 13.5275C15.7032 13.4081 15.6976 13.2946 15.6976 13.2946C15.6976 13.2946 15.622 13.4334 15.5929 13.629C15.5641 13.8247 15.5504 14.0811 15.6301 14.2262C15.7207 14.1356 15.921 13.9357 15.921 13.9357L15.9772 13.7014Z",
    fill: "#C7A180"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9219 7.43585L22.2837 6.69327L22.9718 7.73689L21.6061 8.47525L20.9219 7.43585Z",
    fill: "#62728C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 6.43024L22.1118 5.68767L22.2829 6.69334L20.9211 7.43593L20.75 6.43024Z",
    fill: "#5D6C85"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 8.47521L22.9672 7.73686L23.7695 8.20509L22.3947 8.95364L21.6016 8.47521Z",
    fill: "#62728C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8984 5.15683L22.2729 4.40898L22.8023 4.42058L21.4278 5.16843L20.8984 5.15683Z",
    fill: "#5D6C85"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4219 5.16846L22.7963 4.42061L23.1248 4.82281L21.7503 5.57101L21.4219 5.16846Z",
    fill: "#62728D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7532 5.57096L23.1277 4.82276L22.1118 5.68758L20.75 6.43016L21.7532 5.57096Z",
    fill: "#57657D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9114 8.81254L24.2075 8.64991L22.9605 9.71179L22.6641 9.87442L23.9114 8.81254Z",
    fill: "#57657D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8828 8.17567L25.2208 7.44714L25.2531 8.08363L23.9151 8.81252L23.8828 8.17567Z",
    fill: "#5C6A83"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4219 5.16849L21.7503 5.57104L20.7471 6.43024L20.9182 7.43592L21.6024 8.47532L22.3956 8.95375L23.6446 7.89081L23.8775 8.17569L23.9098 8.81254L22.6625 9.87442L21.3225 9.09109L20.3175 7.5673L20.0312 5.88648L20.8925 5.15689L21.4219 5.16849Z",
    fill: "#ADC8F7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6484 7.89076L24.9864 7.16188L25.2193 7.44676L23.8813 8.17564L23.6484 7.89076Z",
    fill: "#62728D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M38.218 4.29702C38.218 3.27764 37.139 2.3373 35.8081 1.56873C34.4775 0.800505 33.3984 0.4949 33.3984 1.51428C33.3984 1.59648 33.4076 1.68183 33.4213 1.76895L33.4188 1.76754L34.3426 3.1006L35.8081 3.94681L37.2739 4.79301L38.1977 4.5264L38.1952 4.52499C38.2086 4.45369 38.218 4.37887 38.218 4.29702Z",
    fill: "#C2CFE5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M40.063 7.93779L30.8906 2.64208L31.1284 0.573107L40.3005 5.86882L40.063 7.93779Z",
    fill: "#C2CFE5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8743 4.49787C37.8743 3.47814 36.7956 2.53815 35.4647 1.76958C34.1338 1.00136 33.0547 0.695752 33.0547 1.71513C33.0547 1.79698 33.0642 1.88268 33.0779 1.9698L33.0754 1.96839L33.9989 3.30146L35.4647 4.14766L36.9305 4.99387L37.8543 4.7276L37.8518 4.72584C37.8652 4.65454 37.8743 4.57972 37.8743 4.49787Z",
    fill: "#819CCA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7186 8.13876L30.5469 2.84305L30.7847 0.774081L39.9564 6.06944L39.7186 8.13876Z",
    fill: "#819CCA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0735 34.219L39.9069 34.7663L27.5781 0.686317L28.7447 0.1394L42.3573 7.99902L41.0735 34.219Z",
    fill: "#1C2134"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9017 34.7663L26.2891 26.9067L27.5729 0.686321L41.1859 8.54594L39.9017 34.7663Z",
    fill: "#303446"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2969 26.1008L28.2825 2.47702L40.0486 9.27019L39.063 32.894L27.2969 26.1008Z",
    fill: "#D7D8DB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5751 8.74126L38.2698 8.88L29.3359 1.51568L29.6408 1.37693L38.8129 6.67264L38.5751 8.74126Z",
    fill: "#C2CFE5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5363 9.0015L31.8172 6.85384L30.5312 4.24779L37.1893 8.09241L35.5363 9.0015Z",
    fill: "#9AAFD4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8202 5.09995C36.8336 5.02829 36.843 4.95383 36.843 4.87163C36.843 3.85225 35.764 2.9119 34.4331 2.14368C33.1022 1.37511 32.0234 1.06951 32.0234 2.08889C32.0234 2.17108 32.0329 2.25644 32.0463 2.34356L32.0438 2.3425L32.9673 3.67521L34.4331 4.52142L35.8989 5.36761L36.3987 5.2236L36.4616 5.30264L36.8121 5.10416L36.8227 5.10136L36.8202 5.09995Z",
    fill: "#C2CFE5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4837 5.07286C36.4837 4.05348 35.405 3.11314 34.074 2.34457C32.7431 1.57635 31.6641 1.27074 31.6641 2.29012C31.6641 2.37232 31.6736 2.45768 31.6869 2.54444L31.6848 2.54338L32.6082 3.87644L34.074 4.72265L35.5395 5.56885L36.463 5.30224L36.4608 5.30083C36.4745 5.22953 36.4837 5.15471 36.4837 5.07286Z",
    fill: "#A7B9D9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2654 8.87988L29.0938 3.58452L29.3316 1.51556L38.5036 6.81092L38.2654 8.87988Z",
    fill: "#A7B9D9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.7922 36.5412C46.7279 37.1862 45.6632 37.6087 44.4141 37.4847C43.1651 37.3604 42.2044 36.7372 42.2687 36.092C42.3322 35.447 43.3973 35.0248 44.646 35.1488C45.8954 35.2728 46.8557 35.8963 46.7922 36.5412Z",
    fill: "#8F4300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 17,
    width: 3,
    height: 4
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8261 17.8816C40.8261 17.8816 39.76 18.8511 39.4421 19.0713C39.1239 19.2915 39.7048 20.475 40.2489 20.1455C41.5458 19.3597 41.8134 18.9139 41.8134 18.9139L40.8261 17.8816Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8261 17.8816C40.8261 17.8816 39.76 18.8511 39.4421 19.0713C39.1239 19.2915 39.7048 20.475 40.2489 20.1455C41.5458 19.3597 41.8134 18.9139 41.8134 18.9139L40.8261 17.8816Z",
    fill: "url(#paint8_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 19,
    width: 3,
    height: 5
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8918 19.1792C39.857 19.123 39.6768 18.9369 39.5036 19.0261C39.3308 19.1153 39.1952 19.344 39.1303 19.5467C39.0649 19.749 38.6989 21.6687 38.6989 21.6687L38.4948 22.0308L38.4453 22.3565C38.4453 22.3565 38.5633 23.0291 38.6796 23.1271C38.7962 23.2258 39.4046 23.2683 39.4046 23.2683L39.5704 22.9424C39.5704 22.9424 39.6515 22.3979 39.6466 22.3442C39.6424 22.2904 39.5504 22.1629 39.5504 22.1629L39.164 22.1611L39.49 21.6669C39.49 21.6669 40.3154 20.279 40.4124 19.8649C40.5093 19.4508 39.8918 19.1792 39.8918 19.1792Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8918 19.1792C39.857 19.123 39.6768 18.9369 39.5036 19.0261C39.3308 19.1153 39.1952 19.344 39.1303 19.5467C39.0649 19.749 38.6989 21.6687 38.6989 21.6687L38.4948 22.0308L38.4453 22.3565C38.4453 22.3565 38.5633 23.0291 38.6796 23.1271C38.7962 23.2258 39.4046 23.2683 39.4046 23.2683L39.5704 22.9424C39.5704 22.9424 39.6515 22.3979 39.6466 22.3442C39.6424 22.2904 39.5504 22.1629 39.5504 22.1629L39.164 22.1611L39.49 21.6669C39.49 21.6669 40.3154 20.279 40.4124 19.8649C40.5093 19.4508 39.8918 19.1792 39.8918 19.1792Z",
    fill: "url(#paint9_linear_3227_19821)"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M39.246 21.6523C39.246 21.6523 39.071 21.6105 39.0082 21.7043C38.9456 21.7981 38.9952 22.176 38.9952 22.176C38.9952 22.176 39.1381 22.4848 39.1715 22.4925C39.2056 22.5003 39.3334 22.5161 39.351 22.4627C39.3686 22.4096 39.3661 21.9512 39.3661 21.9512L39.3991 21.6839L39.246 21.6523Z",
    fill: "#FFBDA7"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9178 21.9844C38.9765 22.0212 39.1373 22.0427 39.2473 22.0181C39.3576 21.9935 39.6698 21.6471 39.6698 21.6471L39.7608 21.2962C39.7415 21.2674 39.66 21.1673 39.6105 21.1944C39.5613 21.2207 39.2462 21.5537 39.2462 21.5537L38.8549 21.7747C38.8549 21.7747 38.7446 21.8758 38.9178 21.9844Z",
    fill: "#DE7E2C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5746 16.3549C42.5746 16.3549 42.2978 16.1557 41.5451 16.8551C41.2019 17.1737 40.4685 17.976 40.4299 18.1186C40.3909 18.2616 40.4843 19.0228 40.943 19.2782C41.4014 19.5339 41.5855 19.392 41.5855 19.392L42.8971 18.1671L42.5746 16.3549Z",
    fill: "#C7A180"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8805 34.1701C43.8805 34.1701 43.7224 34.5066 43.5022 34.6675C43.2096 34.8803 42.369 35.6187 42.3574 35.8228C42.3494 35.9598 42.3399 36.0971 42.4017 36.1814C42.578 36.4214 42.872 36.3764 42.872 36.3764C42.872 36.3764 43.6729 36.1358 43.9862 35.7719C44.1878 35.5383 44.4344 35.3858 44.543 35.357C45.3294 35.1477 45.4071 34.9639 45.4513 34.7279C45.4956 34.4922 45.2476 34.0275 45.2476 34.0275L44.7449 33.7464L43.8805 34.1701Z",
    fill: "#1C2134"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7808 35.5938C42.7337 35.6156 42.3466 35.8805 42.2992 36.0452C42.2511 36.2103 42.315 36.3009 42.315 36.3009C42.315 36.3009 42.4453 36.5605 42.8672 36.524C43.289 36.4871 43.7295 36.1825 43.864 36.0989C43.9986 36.015 44.2796 35.6985 44.2796 35.6985C44.2796 35.6985 44.4858 35.5738 44.602 35.5787C44.7696 35.5861 45.3955 35.2689 45.5459 35.0722C45.634 34.9566 45.6073 34.7578 45.4992 34.5801C45.391 34.4027 45.183 34.3141 45.183 34.3141L42.7808 35.5938Z",
    fill: "#1C2134"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8989 34.4694C44.8912 34.4364 44.8834 34.4027 44.875 34.3686C44.9027 34.3419 44.9273 34.3148 44.9477 34.2881C44.9481 34.3415 44.9484 34.3935 44.9488 34.4427L44.8989 34.4694Z",
    fill: "#111932"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9419 34.6896C44.9257 34.6194 44.9089 34.546 44.8906 34.4694L44.9405 34.4427C44.9412 34.533 44.9416 34.6155 44.9419 34.6896Z",
    fill: "#111932"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7652 34.6075C45.4132 34.5945 45.0981 34.708 45.0981 34.708C45.0981 34.708 44.9987 35.0613 44.4321 35.9146C44.3039 36.1078 44.1455 36.4854 44.0949 36.6382C44.044 36.7906 44.0879 37.0569 44.0879 37.0569C44.0879 37.0569 44.2846 37.2972 44.7915 37.2427C45.2987 37.1876 45.8748 36.4903 45.9485 36.2655C46.0226 36.041 46.3581 35.7583 46.4382 35.5591C46.4951 35.4161 46.4979 34.9605 46.4979 34.9605L46.3851 34.2843L45.7652 34.6075Z",
    fill: "#1C2134"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2906 34.821C46.3377 34.8351 46.5769 34.8821 46.5952 35.1013C46.6131 35.3205 46.4979 35.7262 46.4979 35.7262C46.4979 35.7262 46.2502 35.918 46.2228 35.9929C46.1954 36.0677 46.1224 36.5454 45.8477 36.8043C45.5733 37.0639 45.2927 37.3825 44.7388 37.406C44.1978 37.4295 44.032 37.1559 44.032 37.1559C44.032 37.1559 44.0092 36.7811 44.2115 36.5791C44.4142 36.3771 46.2906 34.821 46.2906 34.821Z",
    fill: "#1C2134"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8542 16.2113C45.1346 16.0564 46.1469 16.7951 46.7781 17.1224C47.0124 17.2436 47.2245 19.5209 47.0876 20.3032C46.9513 21.0855 46.7781 22.6904 46.8195 22.9675C46.8606 23.245 46.4437 24.1099 45.5606 24.3336C44.6772 24.5574 44.0927 24.5384 43.4794 24.2866C43.0709 24.1186 42.9037 23.9441 42.9037 23.9441C42.9037 23.9441 41.9743 19.7545 41.9047 19.1665C41.8359 18.5785 41.7446 17.304 41.8341 17.0206C41.9571 16.6331 42.067 16.5179 42.3621 16.4097C42.8373 16.2355 43.8542 16.2113 43.8542 16.2113Z",
    fill: "#C7A180"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0759 12.7807C45.0759 12.9616 44.9294 13.1078 44.7489 13.1078C44.5684 13.1078 44.4219 12.9616 44.4219 12.7807C44.4219 12.6002 44.5684 12.4537 44.7489 12.4537C44.9294 12.4537 45.0759 12.6002 45.0759 12.7807Z",
    fill: "#240C00"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2712 13.1373C45.2712 13.3178 45.1251 13.4643 44.9442 13.4643C44.7633 13.4643 44.6172 13.3178 44.6172 13.1373C44.6172 12.9567 44.7633 12.8102 44.9442 12.8102C45.1251 12.8102 45.2712 12.9567 45.2712 13.1373Z",
    fill: "#240C00"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3337 13.5595C45.3337 13.74 45.1873 13.8865 45.0067 13.8865C44.8262 13.8865 44.6797 13.74 44.6797 13.5595C44.6797 13.3789 44.8262 13.2325 45.0067 13.2325C45.1873 13.2325 45.3337 13.3789 45.3337 13.5595Z",
    fill: "#240C00"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3337 14.0428C45.3337 14.2234 45.1873 14.3699 45.0067 14.3699C44.8262 14.3699 44.6797 14.2234 44.6797 14.0428C44.6797 13.8623 44.8262 13.7158 45.0067 13.7158C45.1873 13.7158 45.3337 13.8623 45.3337 14.0428Z",
    fill: "#240C00"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1697 14.3952C45.1697 14.5757 45.0232 14.7222 44.843 14.7222C44.6621 14.7222 44.5156 14.5757 44.5156 14.3952C44.5156 14.2142 44.6621 14.0678 44.843 14.0678C45.0232 14.0678 45.1697 14.2142 45.1697 14.3952Z",
    fill: "#240C00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 13,
    width: 3,
    height: 5
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 15.5229C42.7654 15.6785 43.097 16.4763 43.0194 16.8268C42.9421 17.1774 43.2681 17.3773 43.3984 17.4099C44.0138 17.5645 44.5319 17.0833 44.704 16.8205C44.9938 16.3786 44.8294 16.2272 44.8294 16.2272C44.8294 16.2272 44.4939 15.492 44.5203 15.3332C44.5466 15.1745 44.92 14.5605 44.8463 14.2528C44.7721 13.9447 43.9049 13.8892 43.9049 13.8892L42.7278 15.1323L42.6484 15.5229Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 15.5229C42.7654 15.6785 43.097 16.4763 43.0194 16.8268C42.9421 17.1774 43.2681 17.3773 43.3984 17.4099C44.0138 17.5645 44.5319 17.0833 44.704 16.8205C44.9938 16.3786 44.8294 16.2272 44.8294 16.2272C44.8294 16.2272 44.4939 15.492 44.5203 15.3332C44.5466 15.1745 44.92 14.5605 44.8463 14.2528C44.7721 13.9447 43.9049 13.8892 43.9049 13.8892L42.7278 15.1323L42.6484 15.5229Z",
    fill: "url(#paint10_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 12,
    width: 4,
    height: 5
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1991 14.2488C44.1991 14.2488 44.2413 15.597 44.1099 15.7898C43.9785 15.9826 43.1977 16.4126 43.0632 16.4755C42.824 16.5872 42.4327 16.4597 42.367 16.3069C42.3016 16.1544 42.0487 15.3781 42.0097 14.8663C41.9701 14.3542 41.9437 13.5227 42.0656 13.2034C42.1871 12.8838 43.033 12.7271 43.2729 12.7352C43.5131 12.7432 44.1956 13.2182 44.1956 13.2182L44.1991 14.2488Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1991 14.2488C44.1991 14.2488 44.2413 15.597 44.1099 15.7898C43.9785 15.9826 43.1977 16.4126 43.0632 16.4755C42.824 16.5872 42.4327 16.4597 42.367 16.3069C42.3016 16.1544 42.0487 15.3781 42.0097 14.8663C41.9701 14.3542 41.9437 13.5227 42.0656 13.2034C42.1871 12.8838 43.033 12.7271 43.2729 12.7352C43.5131 12.7432 44.1956 13.2182 44.1956 13.2182L44.1991 14.2488Z",
    fill: "url(#paint11_linear_3227_19821)"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0089 13.3674C42.0925 13.5117 43.1603 13.8581 43.5976 13.6136C43.6359 14.0102 43.6348 14.3425 43.6348 14.3425C43.6348 14.3425 43.86 14.4303 43.9243 14.6116C43.9882 14.7928 43.9604 15.0717 43.9604 15.0717L44.1909 15.0851C44.1909 15.0851 44.2292 14.6807 44.3395 14.561C44.4494 14.4415 44.4627 14.4078 44.591 14.5645C44.7195 14.7204 44.5365 15.0134 44.5365 15.0134L44.5239 15.3334C44.5239 15.3334 44.8175 15.104 44.9159 14.7893C45.0142 14.4742 45.1656 13.6414 45.0107 13.1513C44.8555 12.6613 44.3307 12.4523 44.3307 12.4523C44.2074 12.4084 44.1845 12.4467 44.1094 12.4168C43.7479 12.2728 43.0725 12.093 42.5888 12.1762C42.0327 12.2721 41.9685 12.4295 41.9109 12.8644C41.8806 13.0983 42.0089 13.3674 42.0089 13.3674Z",
    fill: "#240C00"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2869 13.1324C42.2869 13.3129 42.1404 13.4594 41.9598 13.4594C41.7789 13.4594 41.6328 13.3129 41.6328 13.1324C41.6328 12.9518 41.7789 12.8054 41.9598 12.8054C42.1404 12.8054 42.2869 12.9518 42.2869 13.1324Z",
    fill: "#240C00"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6856 13.4594C42.6856 13.64 42.5392 13.7865 42.3583 13.7865C42.1777 13.7865 42.0312 13.64 42.0312 13.4594C42.0312 13.2789 42.1777 13.1324 42.3583 13.1324C42.5392 13.1324 42.6856 13.2789 42.6856 13.4594Z",
    fill: "#240C00"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2169 13.5623C43.2169 13.7428 43.0704 13.8893 42.8899 13.8893C42.709 13.8893 42.5625 13.7428 42.5625 13.5623C42.5625 13.3814 42.709 13.2349 42.8899 13.2349C43.0704 13.2349 43.2169 13.3814 43.2169 13.5623Z",
    fill: "#240C00"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6931 13.4927C43.6931 13.6733 43.5466 13.8198 43.3661 13.8198C43.1855 13.8198 43.0391 13.6733 43.0391 13.4927C43.0391 13.3122 43.1855 13.1657 43.3661 13.1657C43.5466 13.1657 43.6931 13.3122 43.6931 13.4927Z",
    fill: "#240C00"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1935 13.7443C44.1935 13.9248 44.047 14.0713 43.8664 14.0713C43.6855 14.0713 43.5391 13.9248 43.5391 13.7443C43.5391 13.5637 43.6855 13.4172 43.8664 13.4172C44.047 13.4172 44.1935 13.5637 44.1935 13.7443Z",
    fill: "#240C00"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3259 12.5935C42.3259 12.7741 42.1794 12.9202 41.9989 12.9202C41.8183 12.9202 41.6719 12.7741 41.6719 12.5935C41.6719 12.4129 41.8183 12.2665 41.9989 12.2665C42.1794 12.2665 42.3259 12.4129 42.3259 12.5935Z",
    fill: "#240C00"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6856 12.1551C42.6856 12.3356 42.5392 12.4821 42.3583 12.4821C42.1777 12.4821 42.0312 12.3356 42.0312 12.1551C42.0312 11.9745 42.1777 11.8281 42.3583 11.8281C42.5392 11.8281 42.6856 11.9745 42.6856 12.1551Z",
    fill: "#240C00"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2787 12.028C43.2787 12.2085 43.1322 12.355 42.952 12.355C42.7711 12.355 42.625 12.2085 42.625 12.028C42.625 11.8474 42.7711 11.701 42.952 11.701C43.1322 11.701 43.2787 11.8474 43.2787 12.028Z",
    fill: "#240C00"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M43.865 12.0915C43.865 12.2721 43.7185 12.4186 43.5376 12.4186C43.3574 12.4186 43.2109 12.2721 43.2109 12.0915C43.2109 11.911 43.3574 11.7645 43.5376 11.7645C43.7185 11.7645 43.865 11.911 43.865 12.0915Z",
    fill: "#240C00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 14,
    width: 1,
    height: 2
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M44.354 14.7079C44.3667 14.6886 44.4903 14.4206 44.6392 14.4238C44.7882 14.4266 44.9188 14.6458 44.8156 14.846C44.7123 15.0462 44.4492 15.4143 44.3185 15.3213C44.1879 15.2282 44.3403 14.9503 44.3403 14.9503L44.354 14.7079Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.354 14.7079C44.3667 14.6886 44.4903 14.4206 44.6392 14.4238C44.7882 14.4266 44.9188 14.6458 44.8156 14.846C44.7123 15.0462 44.4492 15.4143 44.3185 15.3213C44.1879 15.2282 44.3403 14.9503 44.3403 14.9503L44.354 14.7079Z",
    fill: "url(#paint12_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 30,
    width: 3,
    height: 5
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2124 34.6553C44.0318 34.6553 43.8653 34.5777 43.7698 34.3705C43.7638 34.3575 43.7582 34.3441 43.7529 34.3301C43.5415 33.7839 42.5748 31.4866 42.1319 30.4054C42.2 30.5487 42.2713 30.6558 42.3296 30.6843C42.4589 30.7471 42.9654 31.0152 43.3297 31.0152C43.4235 31.0152 43.5078 30.9976 43.5738 30.954C43.7642 31.3148 44.1776 31.7792 44.499 32.9271C44.6536 33.4797 44.7772 33.9658 44.8735 34.3684C44.7154 34.5194 44.4516 34.6553 44.2124 34.6553Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2124 34.6553C44.0318 34.6553 43.8653 34.5777 43.7698 34.3705C43.7638 34.3575 43.7582 34.3441 43.7529 34.3301C43.5415 33.7839 42.5748 31.4866 42.1319 30.4054C42.2 30.5487 42.2713 30.6558 42.3296 30.6843C42.4589 30.7471 42.9654 31.0152 43.3297 31.0152C43.4235 31.0152 43.5078 30.9976 43.5738 30.954C43.7642 31.3148 44.1776 31.7792 44.499 32.9271C44.6536 33.4797 44.7772 33.9658 44.8735 34.3684C44.7154 34.5194 44.4516 34.6553 44.2124 34.6553Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 24,
    width: 4,
    height: 8
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3264 31.0152C42.9621 31.0152 42.4556 30.7472 42.3264 30.6843C42.2681 30.6559 42.1968 30.5487 42.1286 30.4054C42.0879 30.3204 42.0482 30.2228 42.0131 30.1213C42.0127 30.1206 42.0127 30.1202 42.0124 30.1198C41.9259 29.8719 41.8648 29.6021 41.8764 29.4423C41.9003 29.1068 42.1103 27.8145 42.2895 26.695C42.417 25.8987 42.7282 24.6608 42.8975 24.0124C42.9576 24.1897 43.3271 24.3945 43.802 24.5301C43.7813 25.0981 43.7732 25.8639 43.8666 26.0912C43.9116 26.2007 43.9755 26.2822 44.0437 26.3427C44.036 26.402 43.5723 29.9411 43.4757 30.4873C43.4462 30.6559 43.4866 30.795 43.5705 30.9541C43.5045 30.9977 43.4202 31.0152 43.3264 31.0152Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3264 31.0152C42.9621 31.0152 42.4556 30.7472 42.3264 30.6843C42.2681 30.6559 42.1968 30.5487 42.1286 30.4054C42.0879 30.3204 42.0482 30.2228 42.0131 30.1213C42.0127 30.1206 42.0127 30.1202 42.0124 30.1198C41.9259 29.8719 41.8648 29.6021 41.8764 29.4423C41.9003 29.1068 42.1103 27.8145 42.2895 26.695C42.417 25.8987 42.7282 24.6608 42.8975 24.0124C42.9576 24.1897 43.3271 24.3945 43.802 24.5301C43.7813 25.0981 43.7732 25.8639 43.8666 26.0912C43.9116 26.2007 43.9755 26.2822 44.0437 26.3427C44.036 26.402 43.5723 29.9411 43.4757 30.4873C43.4462 30.6559 43.4866 30.795 43.5705 30.9541C43.5045 30.9977 43.4202 31.0152 43.3264 31.0152Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 22,
    width: 5,
    height: 9
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9378 30.5549C44.9378 30.5549 44.9378 30.5549 44.9375 30.5545C44.8669 30.3343 44.6579 28.722 44.5181 27.6011C44.4404 26.9811 44.3842 26.5118 44.3842 26.5118C44.3842 26.5118 44.1942 26.4893 44.0284 26.3428C43.9603 26.2824 43.8964 26.2009 43.8514 26.0913C43.758 25.864 43.766 25.0983 43.7868 24.5303C44.06 24.6079 44.3684 24.6627 44.673 24.6761C44.7137 24.6778 44.7541 24.6789 44.7942 24.6789C45.5673 24.6789 46.1465 24.3508 46.4707 23.944C46.4707 23.9437 46.4711 23.9433 46.4711 23.9433C46.4711 23.9433 46.4711 23.9433 46.4714 23.9433C46.5209 23.9746 46.5698 24.0136 46.607 24.0789C46.8592 24.5201 46.6175 26.9315 46.5058 28.7128C46.5058 28.7128 46.5058 28.7128 46.5058 28.7132L45.1173 29.2872C45.1173 29.2872 45.1145 29.278 45.1089 29.278C45.0903 29.278 45.0404 29.3781 44.9557 30.2415C44.9484 30.3153 44.9424 30.4224 44.9378 30.5549ZM46.8564 29.5661C46.8561 29.565 46.8561 29.5639 46.8561 29.5625C46.8701 29.4136 47.1662 26.1739 47.1803 25.4285C47.1922 24.7421 47.2263 23.6728 46.8525 22.9204C46.9073 23.0307 46.9537 23.1484 46.9923 23.2703C47.2171 23.9784 47.1904 24.8426 47.1803 25.4288C47.1669 26.1805 46.8648 29.4737 46.8564 29.5661Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9378 30.5549C44.9378 30.5549 44.9378 30.5549 44.9375 30.5545C44.8669 30.3343 44.6579 28.722 44.5181 27.6011C44.4404 26.9811 44.3842 26.5118 44.3842 26.5118C44.3842 26.5118 44.1942 26.4893 44.0284 26.3428C43.9603 26.2824 43.8964 26.2009 43.8514 26.0913C43.758 25.864 43.766 25.0983 43.7868 24.5303C44.06 24.6079 44.3684 24.6627 44.673 24.6761C44.7137 24.6778 44.7541 24.6789 44.7942 24.6789C45.5673 24.6789 46.1465 24.3508 46.4707 23.944C46.4707 23.9437 46.4711 23.9433 46.4711 23.9433C46.4711 23.9433 46.4711 23.9433 46.4714 23.9433C46.5209 23.9746 46.5698 24.0136 46.607 24.0789C46.8592 24.5201 46.6175 26.9315 46.5058 28.7128C46.5058 28.7128 46.5058 28.7128 46.5058 28.7132L45.1173 29.2872C45.1173 29.2872 45.1145 29.278 45.1089 29.278C45.0903 29.278 45.0404 29.3781 44.9557 30.2415C44.9484 30.3153 44.9424 30.4224 44.9378 30.5549ZM46.8564 29.5661C46.8561 29.565 46.8561 29.5639 46.8561 29.5625C46.8701 29.4136 47.1662 26.1739 47.1803 25.4285C47.1922 24.7421 47.2263 23.6728 46.8525 22.9204C46.9073 23.0307 46.9537 23.1484 46.9923 23.2703C47.2171 23.9784 47.1904 24.8426 47.1803 25.4288C47.1669 26.1805 46.8648 29.4737 46.8564 29.5661Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 28,
    width: 3,
    height: 8
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M45.312 35.2883C45.1135 35.2883 44.96 35.229 44.9428 35.0533C44.9417 35.0417 44.9414 35.0294 44.9414 35.0168C44.9421 34.9497 44.9417 34.837 44.941 34.6894C44.9407 34.6153 44.9403 34.5328 44.9396 34.4425C44.9393 34.3933 44.9389 34.3413 44.9386 34.2879C44.9361 33.8559 44.9322 33.2952 44.9305 32.7262C44.928 31.8958 44.9305 31.0478 44.9488 30.5546C44.9533 30.4222 44.9593 30.3151 44.9667 30.2413C45.0513 29.3779 45.1012 29.2778 45.1198 29.2778C45.1254 29.2778 45.1282 29.2869 45.1282 29.2869L46.5168 28.713C46.4743 29.3913 46.4518 29.9786 46.4816 30.3309L46.4866 30.391C46.5884 31.6285 46.4982 32.3131 46.2839 34.0536C46.2375 34.427 46.1943 34.7758 46.1536 35.0951C46.0696 35.1274 45.9562 35.1668 45.8318 35.2019C45.6618 35.2493 45.4721 35.2883 45.312 35.2883ZM46.1609 35.0923C46.2101 35.0727 46.2484 35.0561 46.2716 35.0456C46.2906 35.0365 46.3081 35.0263 46.3243 35.015C46.3081 35.0263 46.2906 35.0365 46.2712 35.046C46.2481 35.0568 46.2098 35.0734 46.1609 35.0923ZM46.4813 34.8078C46.521 34.7003 46.5178 34.6037 46.5178 34.6037C46.5178 34.6037 46.5213 34.7003 46.4813 34.8078ZM46.8877 29.7397C46.881 29.6789 46.874 29.6203 46.8666 29.5634C46.8666 29.563 46.867 29.5627 46.867 29.5623C46.867 29.5637 46.867 29.5648 46.8673 29.5658C46.8744 29.622 46.881 29.68 46.8877 29.7397Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.312 35.2883C45.1135 35.2883 44.96 35.229 44.9428 35.0533C44.9417 35.0417 44.9414 35.0294 44.9414 35.0168C44.9421 34.9497 44.9417 34.837 44.941 34.6894C44.9407 34.6153 44.9403 34.5328 44.9396 34.4425C44.9393 34.3933 44.9389 34.3413 44.9386 34.2879C44.9361 33.8559 44.9322 33.2952 44.9305 32.7262C44.928 31.8958 44.9305 31.0478 44.9488 30.5546C44.9533 30.4222 44.9593 30.3151 44.9667 30.2413C45.0513 29.3779 45.1012 29.2778 45.1198 29.2778C45.1254 29.2778 45.1282 29.2869 45.1282 29.2869L46.5168 28.713C46.4743 29.3913 46.4518 29.9786 46.4816 30.3309L46.4866 30.391C46.5884 31.6285 46.4982 32.3131 46.2839 34.0536C46.2375 34.427 46.1943 34.7758 46.1536 35.0951C46.0696 35.1274 45.9562 35.1668 45.8318 35.2019C45.6618 35.2493 45.4721 35.2883 45.312 35.2883ZM46.1609 35.0923C46.2101 35.0727 46.2484 35.0561 46.2716 35.0456C46.2906 35.0365 46.3081 35.0263 46.3243 35.015C46.3081 35.0263 46.2906 35.0365 46.2712 35.046C46.2481 35.0568 46.2098 35.0734 46.1609 35.0923ZM46.4813 34.8078C46.521 34.7003 46.5178 34.6037 46.5178 34.6037C46.5178 34.6037 46.5213 34.7003 46.4813 34.8078ZM46.8877 29.7397C46.881 29.6789 46.874 29.6203 46.8666 29.5634C46.8666 29.563 46.867 29.5627 46.867 29.5623C46.867 29.5637 46.867 29.5648 46.8673 29.5658C46.8744 29.622 46.881 29.68 46.8877 29.7397Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 16,
    width: 3,
    height: 6
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2252 16.8165C45.667 16.6654 44.9916 17.5822 44.8763 18.5229C44.7611 19.4636 45.0277 21.3773 44.8763 21.3847C44.7249 21.3921 44.3723 21.463 44.3063 21.2888C44.2402 21.1149 44.1232 19.2824 44.2318 18.4126C44.3407 17.5425 44.9188 16.7329 45.2947 16.6342C45.6702 16.5355 45.7819 16.5867 45.7819 16.5867L46.2252 16.8165Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2252 16.8165C45.667 16.6654 44.9916 17.5822 44.8763 18.5229C44.7611 19.4636 45.0277 21.3773 44.8763 21.3847C44.7249 21.3921 44.3723 21.463 44.3063 21.2888C44.2402 21.1149 44.1232 19.2824 44.2318 18.4126C44.3407 17.5425 44.9188 16.7329 45.2947 16.6342C45.6702 16.5355 45.7819 16.5867 45.7819 16.5867L46.2252 16.8165Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 16,
    width: 2,
    height: 6
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3995 16.2208C42.6759 16.2742 42.5519 17.159 42.566 18.1162C42.5804 19.0738 42.8017 21.1715 42.7655 21.1684C42.7293 21.1649 42.4416 21.2211 42.246 20.9313C42.0503 20.6411 42.0423 18.7229 42.0391 18.0414C42.0363 17.3599 42.1677 16.48 42.5354 16.3701C42.9035 16.2598 43.3995 16.2208 43.3995 16.2208Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3995 16.2208C42.6759 16.2742 42.5519 17.159 42.566 18.1162C42.5804 19.0738 42.8017 21.1715 42.7655 21.1684C42.7293 21.1649 42.4416 21.2211 42.246 20.9313C42.0503 20.6411 42.0423 18.7229 42.0391 18.0414C42.0363 17.3599 42.1677 16.48 42.5354 16.3701C42.9035 16.2598 43.3995 16.2208 43.3995 16.2208Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 19,
    width: 6,
    height: 6
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8078 24.6788C44.7677 24.6788 44.7273 24.6778 44.6866 24.676C44.382 24.6627 44.0736 24.6079 43.8004 24.5303C43.3255 24.3947 42.9559 24.1899 42.8959 24.0125C42.8344 23.8302 42.3384 21.8634 42.1164 20.7622C42.0911 20.6358 42.0711 20.5188 42.0557 20.412C41.9995 20.0253 42.0012 19.7759 42.0002 19.7038V19.7035C41.9974 19.4738 42.03 19.1784 42.0964 19.1784C42.1062 19.1784 42.1171 19.185 42.1287 19.1998C42.2169 19.3129 42.4902 19.6452 43.33 19.9062C43.6753 20.0133 44.0076 20.0323 44.2851 20.0323C44.3617 20.0323 44.434 20.0309 44.5015 20.0295C44.5689 20.0281 44.6311 20.0267 44.6876 20.0267C44.8685 20.0267 44.9897 20.0414 45.0224 20.1187C45.112 20.3312 45.107 20.667 45.2117 20.8623C45.3006 21.0278 45.9058 21.2154 46.2634 21.2154C46.2715 21.2154 46.2792 21.2154 46.2866 21.215V21.2154C46.2996 21.6685 46.2701 22.1167 46.2441 22.5186C46.2125 22.9819 46.1847 23.383 46.23 23.6588C46.2493 23.7736 46.3003 23.8295 46.3631 23.8709C46.4014 23.8962 46.4439 23.9173 46.4847 23.9433C46.4847 23.9433 46.4843 23.9436 46.4843 23.944C46.1601 24.3508 45.5809 24.6788 44.8078 24.6788ZM47.0534 20.5304C47.0548 20.5191 47.0558 20.51 47.0565 20.5037V20.503L47.0569 20.4998C47.0562 20.5061 47.0551 20.5167 47.0534 20.5304Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8078 24.6788C44.7677 24.6788 44.7273 24.6778 44.6866 24.676C44.382 24.6627 44.0736 24.6079 43.8004 24.5303C43.3255 24.3947 42.9559 24.1899 42.8959 24.0125C42.8344 23.8302 42.3384 21.8634 42.1164 20.7622C42.0911 20.6358 42.0711 20.5188 42.0557 20.412C41.9995 20.0253 42.0012 19.7759 42.0002 19.7038V19.7035C41.9974 19.4738 42.03 19.1784 42.0964 19.1784C42.1062 19.1784 42.1171 19.185 42.1287 19.1998C42.2169 19.3129 42.4902 19.6452 43.33 19.9062C43.6753 20.0133 44.0076 20.0323 44.2851 20.0323C44.3617 20.0323 44.434 20.0309 44.5015 20.0295C44.5689 20.0281 44.6311 20.0267 44.6876 20.0267C44.8685 20.0267 44.9897 20.0414 45.0224 20.1187C45.112 20.3312 45.107 20.667 45.2117 20.8623C45.3006 21.0278 45.9058 21.2154 46.2634 21.2154C46.2715 21.2154 46.2792 21.2154 46.2866 21.215V21.2154C46.2996 21.6685 46.2701 22.1167 46.2441 22.5186C46.2125 22.9819 46.1847 23.383 46.23 23.6588C46.2493 23.7736 46.3003 23.8295 46.3631 23.8709C46.4014 23.8962 46.4439 23.9173 46.4847 23.9433C46.4847 23.9433 46.4843 23.9436 46.4843 23.944C46.1601 24.3508 45.5809 24.6788 44.8078 24.6788ZM47.0534 20.5304C47.0548 20.5191 47.0558 20.51 47.0565 20.5037V20.503L47.0569 20.4998C47.0562 20.5061 47.0551 20.5167 47.0534 20.5304Z",
    fill: "#8F4300"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4531 34.8812C46.4531 34.8808 46.4531 34.8808 46.4531 34.8808C46.463 34.864 46.471 34.8471 46.4784 34.8299C46.471 34.8471 46.463 34.864 46.4531 34.8812Z",
    fill: "#111932"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5234 34.6032C46.5322 34.5667 46.9702 32.7682 46.9787 31.3105C46.9822 30.7252 46.9425 30.1818 46.893 29.7399C46.9428 30.1818 46.9829 30.7252 46.979 31.3105C46.9706 32.7679 46.5322 34.5667 46.5234 34.6032Z",
    fill: "#7E9ED9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 19,
    width: 2,
    height: 4
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8713 22.9204C46.871 22.92 46.871 22.9197 46.871 22.9197C46.8383 22.514 47.0273 20.8082 47.0585 20.5304C47.028 20.8061 46.8387 22.5136 46.8713 22.9193V22.9204ZM47.0603 20.5082C47.0719 20.4352 47.0831 20.3667 47.094 20.3031C47.1355 20.066 47.1449 19.6912 47.1316 19.2805C47.1453 19.6912 47.1362 20.066 47.0947 20.3034C47.0842 20.3617 47.074 20.4253 47.0631 20.4924L47.062 20.4998C47.0628 20.4949 47.0628 20.4924 47.0628 20.4921C47.062 20.4977 47.0613 20.5029 47.0603 20.5082Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8713 22.9204C46.871 22.92 46.871 22.9197 46.871 22.9197C46.8383 22.514 47.0273 20.8082 47.0585 20.5304C47.028 20.8061 46.8387 22.5136 46.8713 22.9193V22.9204ZM47.0603 20.5082C47.0719 20.4352 47.0831 20.3667 47.094 20.3031C47.1355 20.066 47.1449 19.6912 47.1316 19.2805C47.1453 19.6912 47.1362 20.066 47.0947 20.3034C47.0842 20.3617 47.074 20.4253 47.0631 20.4924L47.062 20.4998C47.0628 20.4949 47.0628 20.4924 47.0628 20.4921C47.062 20.4977 47.0613 20.5029 47.0603 20.5082Z",
    fill: "url(#paint13_linear_3227_19821)"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1562 35.0954C46.1587 35.0943 46.1612 35.0933 46.1636 35.0926C46.1612 35.0936 46.1587 35.0943 46.1562 35.0954ZM46.327 35.0153C46.3821 34.9777 46.4218 34.9303 46.4499 34.8808C46.4499 34.8808 46.4499 34.8808 46.4499 34.8811C46.4218 34.9303 46.3821 34.9781 46.327 35.0153Z",
    fill: "#111932"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2899 21.215V21.2143C46.2952 21.1753 46.4276 20.1774 46.0352 18.9163C45.9629 18.6831 46.0409 18.5981 46.1856 18.5981C46.4216 18.5981 46.835 18.8243 47.0613 19.0024L47.1199 19.0537C47.1238 19.1302 47.1269 19.2061 47.1297 19.2806C47.1431 19.6912 47.1336 20.066 47.0922 20.3031C47.0813 20.3667 47.07 20.4352 47.0584 20.5083C47.0008 20.8514 46.7149 21.1117 46.4297 21.1964C46.3914 21.208 46.344 21.214 46.2899 21.215Z",
    fill: "#8F4300",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 29,
    width: 2,
    height: 6
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8778 34.3685C44.7815 33.966 44.6579 33.4798 44.5033 32.9273C44.1819 31.7793 43.7685 31.3149 43.5781 30.9542C43.6097 30.9335 43.6368 30.9068 43.6589 30.8738C43.792 30.6749 43.9048 30.2654 43.9817 29.9239C44.0341 29.9822 44.0878 30.0504 44.1412 30.1298C44.366 30.461 44.7222 31.8208 44.9424 32.7263C44.9442 33.2954 44.948 33.856 44.9505 34.2881C44.9301 34.3148 44.9055 34.3418 44.8778 34.3685Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8778 34.3685C44.7815 33.966 44.6579 33.4798 44.5033 32.9273C44.1819 31.7793 43.7685 31.3149 43.5781 30.9542C43.6097 30.9335 43.6368 30.9068 43.6589 30.8738C43.792 30.6749 43.9048 30.2654 43.9817 29.9239C44.0341 29.9822 44.0878 30.0504 44.1412 30.1298C44.366 30.461 44.7222 31.8208 44.9424 32.7263C44.9442 33.2954 44.948 33.856 44.9505 34.2881C44.9301 34.3148 44.9055 34.3418 44.8778 34.3685Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 26,
    width: 2,
    height: 5
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5732 30.9542C43.4892 30.7951 43.4488 30.656 43.4784 30.4874C43.575 29.9412 44.0386 26.4021 44.0463 26.3428C44.2121 26.4892 44.4022 26.5117 44.4022 26.5117C44.4022 26.5117 44.4584 26.981 44.536 27.601C44.3087 28.4841 44.0846 29.3714 44.0846 29.3714C44.0846 29.3714 44.0449 29.6208 43.9768 29.9239C43.8999 30.2654 43.7871 30.6749 43.654 30.8738C43.6319 30.9068 43.6048 30.9335 43.5732 30.9542Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5732 30.9542C43.4892 30.7951 43.4488 30.656 43.4784 30.4874C43.575 29.9412 44.0386 26.4021 44.0463 26.3428C44.2121 26.4892 44.4022 26.5117 44.4022 26.5117C44.4022 26.5117 44.4584 26.981 44.536 27.601C44.3087 28.4841 44.0846 29.3714 44.0846 29.3714C44.0846 29.3714 44.0449 29.6208 43.9768 29.9239C43.8999 30.2654 43.7871 30.6749 43.654 30.8738C43.6319 30.9068 43.6048 30.9335 43.5732 30.9542Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 22,
    width: 2,
    height: 8
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8537 29.5625C46.7828 28.9927 46.703 28.6305 46.703 28.6305L46.5035 28.7131C46.5035 28.7127 46.5035 28.7127 46.5035 28.7127C46.6152 26.9315 46.8569 24.52 46.6047 24.0788C46.5675 24.0135 46.5186 23.9745 46.4691 23.9432C46.4688 23.9432 46.4688 23.9432 46.4688 23.9432C46.8091 23.5157 46.8846 23.3608 46.8499 22.9196C46.8499 22.9196 46.8499 22.92 46.8502 22.9203C47.224 23.6728 47.1899 24.742 47.1779 25.4284C47.1639 26.1738 46.8678 29.4135 46.8537 29.5625Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8537 29.5625C46.7828 28.9927 46.703 28.6305 46.703 28.6305L46.5035 28.7131C46.5035 28.7127 46.5035 28.7127 46.5035 28.7127C46.6152 26.9315 46.8569 24.52 46.6047 24.0788C46.5675 24.0135 46.5186 23.9745 46.4691 23.9432C46.4688 23.9432 46.4688 23.9432 46.4688 23.9432C46.8091 23.5157 46.8846 23.3608 46.8499 22.9196C46.8499 22.9196 46.8499 22.92 46.8502 22.9203C47.224 23.6728 47.1899 24.742 47.1779 25.4284C47.1639 26.1738 46.8678 29.4135 46.8537 29.5625Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 28,
    width: 1,
    height: 8
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1641 35.0954C46.2048 34.7761 46.248 34.4273 46.2944 34.0539C46.5086 32.3134 46.5989 31.6287 46.4971 30.3912L46.4921 30.3312C46.4623 29.9788 46.4848 29.3915 46.5273 28.7132L46.7268 28.6307C46.7268 28.6307 46.8065 28.9928 46.8775 29.5626C46.8775 29.5629 46.8771 29.5633 46.8771 29.5636C46.8845 29.6205 46.8915 29.6792 46.8982 29.74C46.9477 30.1819 46.9874 30.7253 46.9839 31.3105C46.9755 32.7682 46.5374 34.5667 46.5287 34.6033C46.5283 34.6036 46.5283 34.604 46.5283 34.604C46.5283 34.604 46.5315 34.7006 46.4918 34.8081C46.489 34.8154 46.4862 34.8228 46.483 34.8298C46.4756 34.8471 46.4675 34.8639 46.4577 34.8808C46.4296 34.9303 46.3899 34.9777 46.3348 35.0153C46.3186 35.0265 46.301 35.0367 46.2821 35.0459C46.2589 35.0564 46.2206 35.0729 46.1714 35.0926C46.169 35.0933 46.1665 35.0943 46.1641 35.0954Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1641 35.0954C46.2048 34.7761 46.248 34.4273 46.2944 34.0539C46.5086 32.3134 46.5989 31.6287 46.4971 30.3912L46.4921 30.3312C46.4623 29.9788 46.4848 29.3915 46.5273 28.7132L46.7268 28.6307C46.7268 28.6307 46.8065 28.9928 46.8775 29.5626C46.8775 29.5629 46.8771 29.5633 46.8771 29.5636C46.8845 29.6205 46.8915 29.6792 46.8982 29.74C46.9477 30.1819 46.9874 30.7253 46.9839 31.3105C46.9755 32.7682 46.5374 34.5667 46.5287 34.6033C46.5283 34.6036 46.5283 34.604 46.5283 34.604C46.5283 34.604 46.5315 34.7006 46.4918 34.8081C46.489 34.8154 46.4862 34.8228 46.483 34.8298C46.4756 34.8471 46.4675 34.8639 46.4577 34.8808C46.4296 34.9303 46.3899 34.9777 46.3348 35.0153C46.3186 35.0265 46.301 35.0367 46.2821 35.0459C46.2589 35.0564 46.2206 35.0729 46.1714 35.0926C46.169 35.0933 46.1665 35.0943 46.1641 35.0954Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 20,
    width: 2,
    height: 4
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4816 23.9432C46.4408 23.9172 46.3983 23.8961 46.3601 23.8708C46.2972 23.8294 46.2462 23.7735 46.2269 23.6587C46.1816 23.3829 46.2094 22.9818 46.241 22.5185C46.267 22.1166 46.2965 21.6684 46.2835 21.2153V21.2149C46.3376 21.2139 46.385 21.2079 46.4233 21.1963C46.7085 21.1116 46.9944 20.8513 47.052 20.5082C47.0531 20.5029 47.0538 20.4976 47.0545 20.492C47.0545 20.4924 47.0545 20.4948 47.0538 20.4997L47.0534 20.5029V20.5036C47.0527 20.5099 47.0517 20.5191 47.0503 20.5303C47.019 20.8081 46.83 22.5139 46.8627 22.9196C46.8975 23.3608 46.822 23.5157 46.4816 23.9432Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4816 23.9432C46.4408 23.9172 46.3983 23.8961 46.3601 23.8708C46.2972 23.8294 46.2462 23.7735 46.2269 23.6587C46.1816 23.3829 46.2094 22.9818 46.241 22.5185C46.267 22.1166 46.2965 21.6684 46.2835 21.2153V21.2149C46.3376 21.2139 46.385 21.2079 46.4233 21.1963C46.7085 21.1116 46.9944 20.8513 47.052 20.5082C47.0531 20.5029 47.0538 20.4976 47.0545 20.492C47.0545 20.4924 47.0545 20.4948 47.0538 20.4997L47.0534 20.5029V20.5036C47.0527 20.5099 47.0517 20.5191 47.0503 20.5303C47.019 20.8081 46.83 22.5139 46.8627 22.9196C46.8975 23.3608 46.822 23.5157 46.4816 23.9432Z",
    fill: "#8F4300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 18,
    width: 4,
    height: 4
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9062 19.6322C47.5673 20.0825 47.9653 20.5943 48.4792 20.9523C48.9931 21.3102 49.7395 21.0706 49.789 20.7454C49.8382 20.4197 48.6397 19.0986 48.4809 18.9367C48.3222 18.7748 46.9062 19.6322 46.9062 19.6322Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9062 19.6322C47.5673 20.0825 47.9653 20.5943 48.4792 20.9523C48.9931 21.3102 49.7395 21.0706 49.789 20.7454C49.8382 20.4197 48.6397 19.0986 48.4809 18.9367C48.3222 18.7748 46.9062 19.6322 46.9062 19.6322Z",
    fill: "url(#paint14_linear_3227_19821)"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8397 17.1034C46.8397 17.1034 47.0888 17.2506 48.629 19.0326C48.7341 19.1541 48.6933 19.531 48.0656 19.9005C47.8844 20.0073 47.4997 20.1615 47.2619 20.1071C47.0196 20.0523 46.074 19.0726 45.9254 18.7361C45.7768 18.3992 45.786 17.7416 45.9518 17.2407C46.0673 16.8916 46.3104 16.9035 46.4776 16.9545C46.6701 17.0128 46.8397 17.1034 46.8397 17.1034Z",
    fill: "#C7A180"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 20,
    width: 5,
    height: 7
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0875 20.7427C48.6277 20.6398 48.5645 20.5368 48.385 20.8779C48.2048 21.2183 47.1823 23.4576 47.0632 23.5346C46.9441 23.6118 46.7632 23.5707 46.6842 23.6196C46.6052 23.6687 46.1886 24.1408 46.1714 24.1704C46.1545 24.1999 45.9424 24.4394 45.9617 24.6277C45.9817 24.816 46.2451 24.6783 46.2451 24.6783L46.5226 24.3014L46.6259 24.2346L46.5658 24.6779C46.5658 24.6779 45.8419 25.514 45.8117 25.5733C45.7815 25.6327 45.8524 25.7282 45.9606 25.7043C46.0692 25.6801 46.7566 25.0134 46.7566 25.0134L46.0973 25.9183C46.0973 25.9183 46.0509 26.057 46.1735 26.0524C46.2957 26.0479 46.4102 25.9211 46.4102 25.9211L46.8451 25.3966C46.8451 25.3966 46.4074 25.9667 46.3958 26.0384C46.3839 26.1104 46.536 26.1192 46.536 26.1192L46.837 25.7971C46.837 25.7971 46.9287 25.9316 47.0565 25.6987C47.1848 25.4655 47.4556 24.3435 47.5367 24.1995C47.6172 24.0555 49.9885 21.1891 49.7974 20.7455C49.6063 20.3018 49.0875 20.7427 49.0875 20.7427Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0875 20.7427C48.6277 20.6398 48.5645 20.5368 48.385 20.8779C48.2048 21.2183 47.1823 23.4576 47.0632 23.5346C46.9441 23.6118 46.7632 23.5707 46.6842 23.6196C46.6052 23.6687 46.1886 24.1408 46.1714 24.1704C46.1545 24.1999 45.9424 24.4394 45.9617 24.6277C45.9817 24.816 46.2451 24.6783 46.2451 24.6783L46.5226 24.3014L46.6259 24.2346L46.5658 24.6779C46.5658 24.6779 45.8419 25.514 45.8117 25.5733C45.7815 25.6327 45.8524 25.7282 45.9606 25.7043C46.0692 25.6801 46.7566 25.0134 46.7566 25.0134L46.0973 25.9183C46.0973 25.9183 46.0509 26.057 46.1735 26.0524C46.2957 26.0479 46.4102 25.9211 46.4102 25.9211L46.8451 25.3966C46.8451 25.3966 46.4074 25.9667 46.3958 26.0384C46.3839 26.1104 46.536 26.1192 46.536 26.1192L46.837 25.7971C46.837 25.7971 46.9287 25.9316 47.0565 25.6987C47.1848 25.4655 47.4556 24.3435 47.5367 24.1995C47.6172 24.0555 49.9885 21.1891 49.7974 20.7455C49.6063 20.3018 49.0875 20.7427 49.0875 20.7427Z",
    fill: "url(#paint15_linear_3227_19821)"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7343 16.0212C44.8109 16.1968 44.4618 16.8877 43.9742 17.1196C43.5734 17.3103 43.3708 17.2355 43.3708 17.2355C43.3708 17.2355 43.166 17.1087 43.0862 16.7806C43.0413 16.5951 43.0093 16.5179 43.0093 16.5179C43.0093 16.5179 42.9138 16.6159 42.8885 16.815C42.8632 17.0145 42.7965 17.395 43.0216 17.6307C43.0926 17.715 43.1467 17.7529 43.1467 17.7529L43.349 17.4203L43.4962 17.8242C43.5215 17.846 44.2078 17.7027 44.4832 17.4403C44.7586 17.1775 45.1204 16.6194 45.0958 16.4673C45.0716 16.3148 45.0308 16.2207 45.0234 16.2207C45.0164 16.2207 44.78 15.7693 44.6536 15.823C44.6799 15.8891 44.7343 16.0212 44.7343 16.0212Z",
    fill: "#C7A180"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7207 24.2697L37.9522 24.3115L37.903 24.7383L37.6719 24.6964L37.7207 24.2697Z",
    fill: "#6A81A7"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8438 24.1382L38.0746 24.1804L37.9502 24.3114L37.7188 24.2696L37.8438 24.1382Z",
    fill: "#6B83A9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0065 24.1383L38.2376 24.1801L38.0823 24.1805L37.8516 24.1383H38.0065Z",
    fill: "#556886"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3034 24.5036L38.5345 24.5454L38.3171 24.8465L38.0859 24.8043L38.3034 24.5036Z",
    fill: "#6E86AD"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4427 24.0157L38.6739 24.0575L38.5358 24.5454L38.3047 24.5036L38.4427 24.0157Z",
    fill: "#6E86AE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4459 23.9335L38.6771 23.9753L38.6686 24.0575L38.4375 24.0157L38.4459 23.9335Z",
    fill: "#6A81A7"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3672 20.0893L40.5983 20.1311L40.6447 20.1434L40.4135 20.1016L40.3672 20.0893Z",
    fill: "#4F607C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4127 20.1015L40.6438 20.1433L40.5823 20.6663L40.3516 20.6242L40.4127 20.1015Z",
    fill: "#6B82A8"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2406 21.4497L40.4717 21.4915L38.6764 23.9753L38.4453 23.9335L40.2406 21.4497Z",
    fill: "#6E86AD"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2921 21.4515L40.5229 21.4933L40.4733 21.4916L40.2422 21.4498L40.2921 21.4515Z",
    fill: "#556785"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3516 20.6242L40.5823 20.6664L40.6779 20.7991L40.4464 20.7573L40.3516 20.6242Z",
    fill: "#526481"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6013 21.3166L40.8321 21.3584L40.5198 21.4933L40.2891 21.4515L40.6013 21.3166Z",
    fill: "#607597"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7734 20.1996L41.0046 20.241L41.0678 20.2568L40.8367 20.215L40.7734 20.1996Z",
    fill: "#4F607C"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M40.819 21.0159L41.0498 21.0574L40.8323 21.3584L40.6016 21.3166L40.819 21.0159Z",
    fill: "#6E86AD"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8359 20.215L41.0671 20.2568L41.1415 20.6362L40.9104 20.5947L40.8359 20.215Z",
    fill: "#5F7496"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3667 20.0892L40.413 20.1015L40.3519 20.6241L40.4468 20.7573L40.6024 20.7569L40.7267 20.6259L40.7759 20.1995L40.8391 20.2149L40.9136 20.5946L40.8237 21.0158L40.6062 21.3165L40.294 21.4514L40.2441 21.4496L38.4488 23.9334L38.4404 24.0156L38.3023 24.5035L38.0849 24.8042L38.0393 24.794L38.0997 24.2692L38.0052 24.1382H37.8503L37.7252 24.2696L37.6764 24.6964L37.6125 24.6788L37.5391 24.3012L37.6279 23.8779L37.8454 23.5773L38.1587 23.4441L38.2082 23.4459L40.0038 20.9621L40.0119 20.8799L40.1493 20.3902L40.3667 20.0892Z",
    fill: "#92B2E6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9102 20.5947L41.1414 20.6361L41.0511 21.0573L40.8203 21.0158L40.9102 20.5947Z",
    fill: "#6D85AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 21,
    width: 3,
    height: 3
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6989 21.6687L38.4948 22.0308L38.4453 22.3565C38.4453 22.3565 38.5633 23.0291 38.6796 23.1271C38.7962 23.2258 39.5012 23.2683 39.5012 23.2683L39.8939 22.9701C39.8939 22.9701 40.0924 22.5222 40.0874 22.4685C40.0829 22.4148 40.0225 22.2163 40.0225 22.2163L39.5398 22.2145L38.6989 21.6687Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6989 21.6687L38.4948 22.0308L38.4453 22.3565C38.4453 22.3565 38.5633 23.0291 38.6796 23.1271C38.7962 23.2258 39.5012 23.2683 39.5012 23.2683L39.8939 22.9701C39.8939 22.9701 40.0924 22.5222 40.0874 22.4685C40.0829 22.4148 40.0225 22.2163 40.0225 22.2163L39.5398 22.2145L38.6989 21.6687Z",
    fill: "url(#paint16_linear_3227_19821)"
  }))), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5576 10.3152L30.8457 11.0585L30.9149 9.43879L29.6268 8.6955L29.5576 10.3152ZM31.1594 11.63L29.2109 10.5052L29.3132 8.12398L31.2616 9.24874L31.1594 11.63Z",
    fill: "#5ED660"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4482 14.2184L32.7663 11.5158C32.6237 11.4336 32.5155 11.2007 32.5239 10.9959L32.5348 10.7374C32.5439 10.5326 32.6665 10.4335 32.8091 10.5157L37.4907 13.2184C37.6333 13.3006 37.7418 13.5335 37.7331 13.7383L37.7222 13.9968C37.713 14.2016 37.5904 14.301 37.4482 14.2184Z",
    fill: "#B8BABF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4014 13.9986L30.6894 14.7419L30.7586 13.1225L29.4706 12.3789L29.4014 13.9986ZM31.0031 15.3134L29.0547 14.1886L29.1566 11.8074L31.105 12.9325L31.0031 15.3134Z",
    fill: "#5ED660"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2835 17.902L32.6023 15.1997C32.4597 15.1171 32.3508 14.8846 32.3599 14.6794L32.3708 14.4212C32.3796 14.2165 32.5025 14.1171 32.6448 14.1993L37.3263 16.9019C37.4693 16.9845 37.5775 17.217 37.5691 17.4218L37.5582 17.6803C37.549 17.8851 37.4265 17.9845 37.2835 17.902Z",
    fill: "#B8BABF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2373 17.6824L30.5254 18.4256L30.5946 16.8059L29.3069 16.0623L29.2373 17.6824ZM30.8391 18.9971L28.8906 17.8724L28.9928 15.4908L30.9409 16.6159L30.8391 18.9971Z",
    fill: "#5ED660"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1272 21.5857L32.4457 18.883C32.3031 18.8008 32.1945 18.5679 32.2037 18.3631L32.2146 18.1046C32.2233 17.8998 32.3459 17.8004 32.4885 17.883L37.1701 20.5856C37.3127 20.6678 37.4212 20.9007 37.4128 21.1055L37.4012 21.3637C37.3928 21.5685 37.2699 21.6679 37.1272 21.5857Z",
    fill: "#B8BABF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0889 21.3657L30.3769 22.109L30.4461 20.4897L29.1577 19.746L29.0889 21.3657ZM30.6906 22.6805L28.7422 21.5558L28.8441 19.1745L30.7925 20.2996L30.6906 22.6805Z",
    fill: "#5ED660"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9713 25.2695L32.2897 22.5665C32.1471 22.4843 32.0386 22.2514 32.0474 22.0466L32.0586 21.788C32.067 21.5832 32.19 21.4842 32.3326 21.5664L37.0142 24.269C37.1568 24.3512 37.2653 24.5841 37.2562 24.7889L37.2453 25.0475C37.2365 25.2522 37.1139 25.3517 36.9713 25.2695Z",
    fill: "#B8BABF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9248 25.0495L30.2129 25.7928L30.2824 24.1731L28.9944 23.4294L28.9248 25.0495ZM30.5266 26.3639L28.5781 25.2395L28.6803 22.8579L30.6284 23.983L30.5266 26.3639Z",
    fill: "#5ED660"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8076 28.9527L32.126 26.2501C31.983 26.1675 31.8748 25.935 31.8833 25.7298L31.8945 25.4716C31.9033 25.2669 32.0259 25.1678 32.1688 25.25L36.8504 27.9523C36.9927 28.0349 37.1016 28.2677 37.0924 28.4725L37.0815 28.7307C37.0728 28.9355 36.9498 29.0349 36.8076 28.9527Z",
    fill: "#B8BABF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8904 14.2498L28.9609 12.5265L29.497 12.2377L30.0997 13.3551L31.712 12.2114L32.0643 12.7081L29.8904 14.2498Z",
    fill: "#22A960"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5779 21.6168L28.6484 19.8931L29.1841 19.6044L29.7869 20.7221L31.3995 19.5784L31.7518 20.0751L29.5779 21.6168Z",
    fill: "#22A960"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0466 10.6131L29.1172 8.88944L29.6529 8.6007L30.256 9.71844L31.8682 8.57471L32.2206 9.0714L30.0466 10.6131Z",
    fill: "#22A960"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7267 17.9803L28.7969 16.2566L29.3329 15.9679L29.936 17.0856L31.5483 15.9415L31.9006 16.4382L29.7267 17.9803Z",
    fill: "#22A960"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4142 25.347L28.4844 23.6241L29.02 23.335L29.6232 24.4524L31.2358 23.309L31.5877 23.8057L29.4142 25.347Z",
    fill: "#22A960"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6548 45.2594L27.6484 43.5122L35.3189 39.0837L38.3249 40.8306L30.6548 45.2594Z",
    fill: "#959595"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3003 44.5279L27.9624 43.1692C27.7836 43.0656 27.6726 42.8447 27.6719 42.5306L30.0098 43.8893C30.0109 44.2034 30.1219 44.4243 30.3003 44.5279Z",
    fill: "#343249"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 42,
    width: 4,
    height: 3
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2769 44.5278L27.9389 43.1691C27.7601 43.0655 27.6495 42.8445 27.6484 42.5305L29.9864 43.8892C29.9875 44.2032 30.0985 44.4242 30.2769 44.5278Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2769 44.5278L27.9389 43.1691C27.7601 43.0655 27.6491 42.8445 27.6484 42.5305L29.9864 43.8892C29.9875 44.2032 30.0985 44.4242 30.2769 44.5278Z",
    fill: "#232C33"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30.005 43.8893L27.6671 42.5306L27.6484 36.0156L29.9868 37.3747L30.005 43.8893Z",
    fill: "#232C33"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M32.55 31.2244L30.4766 30.0192L35.6144 30.6757L37.6879 31.8806L32.55 31.2244Z",
    fill: "#323A49"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9868 37.3748L27.6484 36.0157L28.0408 31.4243L30.1143 32.6295L29.9868 37.3748Z",
    fill: "#28323D"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1125 32.6295L28.0391 31.4243L30.4726 30.0192L32.5461 31.2244L30.1125 32.6295Z",
    fill: "#323A49"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5454 31.2245L37.6833 31.8807L38.306 33.1804L38.3225 39.0859C38.3246 39.7174 37.8807 40.4871 37.3306 40.8046L31.0016 44.4589C30.4519 44.7764 30.0047 44.5214 30.0026 43.8895L29.9844 37.3748L30.1119 32.6296L32.5454 31.2245Z",
    fill: "#28323D"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9844 37.3748L31.2057 37.5353L31.31 33.4416L30.1119 32.6295L29.9844 37.3748Z",
    fill: "#2F3842"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2109 37.77L31.3153 33.4416L33.1913 32.3583L37.6576 32.9291L38.0675 33.6995L38.084 39.4641C38.0851 39.834 37.7809 40.3598 37.4581 40.546L31.6732 43.8859C31.4754 44 31.2278 43.8581 31.2271 43.6294L31.2109 37.77Z",
    fill: "#232C33"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9219 37.7774L32.01 34.1221C32.0143 33.9584 32.1031 33.8087 32.2447 33.7269L33.1646 33.1954C33.277 33.1308 33.4077 33.1041 33.5366 33.1206L37.0559 33.5702C37.1465 33.5822 37.2262 33.637 37.2691 33.7178L37.3544 33.8779L37.3681 39.0345C37.3695 39.4915 37.1258 39.9141 36.7302 40.1424L32.2703 42.7176C32.1214 42.804 31.9356 42.6969 31.9352 42.5251L31.9219 37.7774Z",
    fill: "#CA180B"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2642 31.4162L35.1887 30.7906L35.0703 28.729L36.1459 29.3546L36.2642 31.4162Z",
    fill: "#1A2326"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7481 27.6162L32.6719 26.991L36.0548 27.4817L37.1307 28.107L33.7481 27.6162Z",
    fill: "#28323D"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6462 31.0208L30.5703 30.3952L31.5753 27.6247L32.6512 28.25L31.6462 31.0208Z",
    fill: "#2D3640"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M32.654 28.2499L31.5781 27.6246L32.6751 26.9909L33.7514 27.6162L32.654 28.2499Z",
    fill: "#38404A"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7507 27.6162L37.1333 28.1069L37.3209 31.6687L37.0613 31.5184L36.2622 31.4162L36.1438 29.3546L33.835 29.0195L33.1437 29.4185L32.5926 30.9469L31.9238 30.8615L31.6484 31.0207L32.6534 28.2499L33.7507 27.6162Z",
    fill: "#28323D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1132 28.5717L32.3215 30.7556L32.267 30.9056L31.9238 30.8617L31.6484 31.0208L32.6534 28.25L33.1132 28.5717Z",
    fill: "#2F3842"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M36.762 31.3224L36.644 29.2647L34.0306 28.8857L33.176 29.3789L32.5968 30.9469L32.2578 30.9037L33.1173 28.5717L34.052 28.0325L37.1287 28.4786L37.2822 31.3892L36.762 31.3224Z",
    fill: "#232C33"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6484 28.2498L33.1082 28.5716L34.0429 28.0324L33.7458 27.6161L32.6484 28.2498Z",
    fill: "#38404A"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 28.4785L37.1326 28.1069L33.75 27.6162L34.0472 28.0324L37.1238 28.4785Z",
    fill: "#2F3842"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6562 31.4345C31.6555 31.2012 31.5056 30.968 31.2049 30.7874L31.2031 30.1485C31.5038 30.3294 31.6534 30.5626 31.6541 30.7959C31.6548 30.9877 31.6555 31.243 31.6562 31.4345Z",
    fill: "#343249"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2047 30.7875C31.8243 31.1602 31.8032 31.7548 31.1572 32.1149C30.5113 32.4749 29.4853 32.4648 28.8653 32.0917C28.2457 31.7187 28.2668 31.1243 28.9127 30.7639C29.5587 30.4039 30.5851 30.4141 31.2047 30.7875Z",
    fill: "#343249"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4141 30.8054C28.4134 30.5581 28.5802 30.3104 28.9125 30.1253C29.5585 29.7649 30.5845 29.7754 31.2045 30.1485L31.2062 30.7874C30.5866 30.414 29.5602 30.4038 28.9143 30.7639C28.582 30.9494 28.4148 31.197 28.4155 31.4443C28.4151 31.2525 28.4144 30.9968 28.4141 30.8054Z",
    fill: "#343249"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2047 30.1485L30.8478 30.1281C30.4168 29.8682 29.703 29.8612 29.2541 30.112C28.8045 30.3624 28.7898 30.7755 29.2208 31.0351C29.6518 31.2943 30.3655 31.3014 30.8148 31.0513C31.264 30.8008 31.2788 30.3874 30.8478 30.1281L31.2047 30.1485C31.8243 30.5215 31.8032 31.1159 31.1569 31.4763C30.5113 31.8363 29.4849 31.8258 28.8653 31.4528C28.2457 31.0801 28.2668 30.4854 28.9127 30.1253C29.5587 29.7649 30.5847 29.7754 31.2047 30.1485Z",
    fill: "#38404A"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1578 30.5781C31.1574 30.4158 31.0531 30.2539 30.8441 30.1281L30.8438 30.02C31.0531 30.1457 31.1571 30.308 31.1578 30.4703C31.1578 30.5026 31.1578 30.5458 31.1578 30.5781Z",
    fill: "#343249"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9063 30.4769C28.9059 30.3048 29.0218 30.1326 29.2533 30.0037C29.7022 29.7533 30.416 29.7607 30.847 30.0199L30.8473 30.1281C30.4163 29.8681 29.7026 29.8611 29.2536 30.1119C29.0222 30.2405 28.9059 30.4126 28.9066 30.5844C28.9066 30.5524 28.9063 30.5092 28.9063 30.4769Z",
    fill: "#343249"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9066 30.5844L28.9062 30.4769C28.9066 30.6392 29.0109 30.8011 29.2199 30.9269C29.6509 31.1865 30.3647 31.1939 30.8139 30.9431C31.0451 30.8145 31.1613 30.6424 31.161 30.4703V30.5781C31.1617 30.7502 31.0454 30.922 30.8143 31.0513C30.365 31.3014 29.6513 31.2943 29.2203 31.0351C29.0113 30.909 28.907 30.7467 28.9066 30.5844Z",
    fill: "#343249"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M30.847 30.0199C30.416 29.7607 29.7023 29.7533 29.2534 30.0038C28.8041 30.2542 28.789 30.6677 29.22 30.9269C29.651 31.1865 30.3648 31.1939 30.814 30.9431C31.2633 30.6926 31.278 30.2792 30.847 30.0199ZM31.0725 29.8942C31.623 30.2254 31.6043 30.7534 31.0304 31.0734C30.4564 31.3934 29.5453 31.3843 28.9945 31.0527C28.4441 30.7214 28.463 30.1935 29.0367 29.8735C29.6106 29.5535 30.5221 29.5626 31.0725 29.8942Z",
    fill: "#343249"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4739 30.4692C31.4732 30.2623 31.3404 30.055 31.0731 29.8941L31.0703 28.8386C31.3376 28.9995 31.4707 29.2067 31.4711 29.4136C31.4721 29.7304 31.4732 30.1527 31.4739 30.4692Z",
    fill: "#343249"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5938 29.4224C28.593 29.2025 28.7416 28.9826 29.037 28.8178C29.6106 28.4982 30.5225 28.5073 31.0729 28.8386L31.0757 29.8941C30.5253 29.5625 29.6138 29.5534 29.0399 29.8734C28.7448 30.0382 28.5962 30.258 28.5969 30.4776C28.5959 30.1607 28.5948 29.7389 28.5938 29.4224Z",
    fill: "#343249"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 30,
    width: 4,
    height: 3
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4155 31.4443L28.4141 30.8054C28.4144 31.0386 28.5644 31.2719 28.8651 31.4528C29.4847 31.8258 30.5111 31.8363 31.1567 31.4763C31.4893 31.2905 31.6562 31.0432 31.6555 30.7959L31.6576 31.4345C31.6583 31.6818 31.4911 31.9294 31.1588 32.1149C30.5128 32.4749 29.4868 32.4648 28.8668 32.0917C28.5662 31.9105 28.4162 31.6776 28.4155 31.4443Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4155 31.4443L28.4141 30.8054C28.4144 31.0386 28.5644 31.2719 28.8651 31.4528C29.4847 31.8258 30.5111 31.8363 31.1567 31.4763C31.4893 31.2905 31.6562 31.0432 31.6555 30.7959L31.6576 31.4345C31.6583 31.6818 31.4911 31.9294 31.1588 32.1149C30.5128 32.4749 29.4868 32.4648 28.8668 32.0917C28.5662 31.9105 28.4162 31.6776 28.4155 31.4443Z",
    fill: "url(#paint17_linear_3227_19821)"
  }))), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5973 28.7834C30.8983 28.9643 30.8877 29.2527 30.5741 29.428C30.2604 29.6029 29.7623 29.598 29.4613 29.4168C29.1603 29.2359 29.1708 28.9468 29.4845 28.7718C29.7981 28.5969 30.2962 28.6022 30.5973 28.7834Z",
    fill: "#F06056"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 28,
    width: 4,
    height: 3
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5697 29.4282C30.256 29.6031 29.758 29.5982 29.4569 29.4169C29.1559 29.2357 29.1664 28.9469 29.4801 28.772C29.7938 28.5971 30.2919 28.6024 30.5929 28.7836C30.8939 28.9645 30.8834 29.2529 30.5697 29.4282ZM31.065 28.8388C30.5146 28.5075 29.6027 28.4984 29.0291 28.818C28.4551 29.138 28.4362 29.666 28.9869 29.9976C29.5374 30.3288 30.4489 30.338 31.0228 30.018C31.5968 29.6983 31.6154 29.17 31.065 28.8388Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5697 29.4282C30.256 29.6031 29.758 29.5982 29.4569 29.4169C29.1559 29.2357 29.1664 28.9469 29.4801 28.772C29.7938 28.5971 30.2919 28.6024 30.5929 28.7836C30.8939 28.9645 30.8834 29.2529 30.5697 29.4282ZM31.065 28.8388C30.5146 28.5075 29.6027 28.4984 29.0291 28.818C28.4551 29.138 28.4362 29.666 28.9869 29.9976C29.5374 30.3288 30.4489 30.338 31.0228 30.018C31.5968 29.6983 31.6154 29.17 31.065 28.8388Z",
    fill: "url(#paint18_linear_3227_19821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 29,
    width: 4,
    height: 3
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5891 30.4779L28.5859 29.4227C28.5866 29.6299 28.7198 29.8372 28.9871 29.9977C29.5375 30.329 30.449 30.3381 31.023 30.0184C31.3184 29.8533 31.4666 29.6338 31.4659 29.4139L31.4687 30.4695C31.4694 30.689 31.3212 30.9089 31.0258 31.0736C30.4518 31.3936 29.5407 31.3845 28.9899 31.0529C28.7229 30.892 28.5898 30.6851 28.5891 30.4779Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5891 30.4779L28.5859 29.4227C28.5866 29.6299 28.7198 29.8372 28.9871 29.9977C29.5375 30.329 30.449 30.3381 31.023 30.0184C31.3184 29.8533 31.4666 29.6338 31.4659 29.4139L31.4687 30.4695C31.4694 30.689 31.3212 30.9089 31.0258 31.0736C30.4518 31.3936 29.5407 31.3845 28.9899 31.0529C28.7229 30.892 28.5898 30.6851 28.5891 30.4779Z",
    fill: "url(#paint19_linear_3227_19821)"
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1172 32.6295L31.3153 33.4417L33.1914 32.3584L32.5507 31.2245L30.1172 32.6295Z",
    fill: "#38404A"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6847 31.8806L37.6538 32.9291L33.1876 32.3583L32.5469 31.2244L37.6847 31.8806Z",
    fill: "#2F3842"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_3227_19821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 31,
    width: 2,
    height: 6
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6329 32.3498C29.3498 32.3083 29.0825 32.2223 28.8651 32.0916C28.5644 31.9104 28.4144 31.6775 28.4141 31.4442C28.4141 31.4442 28.5662 36.6324 28.8668 36.8134C29.0836 36.944 29.6329 32.3498 29.6329 32.3498Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_3227_19821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6329 32.3498C29.3498 32.3083 29.0825 32.2223 28.8651 32.0916C28.5644 31.9104 28.4144 31.6775 28.4141 31.4442C28.4141 31.4442 28.5662 36.6324 28.8668 36.8134C29.0836 36.944 29.6329 32.3498 29.6329 32.3498Z",
    fill: "url(#paint20_linear_3227_19821)"
  }))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9297 40.8056L31.9346 42.5251C31.935 42.6969 32.1208 42.804 32.2697 42.7176L36.7296 40.1424C37.1251 39.9141 37.3689 39.4915 37.3675 39.0345L37.3636 37.6681L31.9297 40.8056Z",
    fill: "#FF9B00"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4904 34.4726C34.4904 34.4726 33.5156 36.4189 33.5156 37.5838C33.5156 38.2529 33.9519 38.5431 34.4904 38.2322V34.4726Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4922 34.4727C34.4922 34.4727 35.4676 35.2932 35.4676 36.4577C35.4676 37.1265 35.0307 37.921 34.4922 38.2323V34.4727Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2819 36.6188C34.2145 36.8746 34.0603 37.0983 33.937 37.119C33.8137 37.1398 33.7684 36.9494 33.8362 36.6937C33.9033 36.4379 34.0582 36.2138 34.1811 36.1931C34.3044 36.1727 34.3494 36.3631 34.2819 36.6188Z",
    fill: "#FF9B00"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3494 12.2057C44.3494 12.3863 44.2029 12.5324 44.0223 12.5324C43.8414 12.5324 43.6953 12.3863 43.6953 12.2057C43.6953 12.0252 43.8414 11.8787 44.0223 11.8787C44.2029 11.8787 44.3494 12.0252 44.3494 12.2057Z",
    fill: "#240C00"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M44.74 12.3901C44.74 12.5707 44.5939 12.7172 44.413 12.7172C44.2324 12.7172 44.0859 12.5707 44.0859 12.3901C44.0859 12.2092 44.2324 12.0628 44.413 12.0628C44.5939 12.0628 44.74 12.2092 44.74 12.3901Z",
    fill: "#240C00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3227_19821",
    x1: 13.1548,
    y1: 15.7451,
    x2: 14.6903,
    y2: 15.8827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137838,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77027,
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9574"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3227_19821",
    x1: 13.0144,
    y1: 19.1629,
    x2: 14.7396,
    y2: 19.2064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137838,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77027,
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9574"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3227_19821",
    x1: 19.9922,
    y1: 16.914,
    x2: 23.0542,
    y2: 16.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3227_19821",
    x1: 24.2344,
    y1: 16.6548,
    x2: 24.8445,
    y2: 16.6548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3227_19821",
    x1: 14.8711,
    y1: 12.053,
    x2: 17.72,
    y2: 12.1835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142993,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9574"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3227_19821",
    x1: 14.9064,
    y1: 11.336,
    x2: 17.7553,
    y2: 11.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142993,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9574"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3227_19821",
    x1: 14.9061,
    y1: 11.3005,
    x2: 17.7549,
    y2: 11.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142993,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9574"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3227_19821",
    x1: 23.4375,
    y1: 17.5113,
    x2: 24.9325,
    y2: 17.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#FF9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#FFCAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3227_19821",
    x1: 41.1229,
    y1: 19.9927,
    x2: 39.9238,
    y2: 18.3468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3227_19821",
    x1: 40.2445,
    y1: 21.4769,
    x2: 38.7175,
    y2: 20.9021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3227_19821",
    x1: 45.3436,
    y1: 15.8598,
    x2: 42.3806,
    y2: 15.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3227_19821",
    x1: 45.4756,
    y1: 14.9257,
    x2: 42.5126,
    y2: 14.5614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3227_19821",
    x1: 45.4594,
    y1: 14.9974,
    x2: 42.4964,
    y2: 14.6331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3227_19821",
    x1: 86.0767,
    y1: 120.155,
    x2: -24.8981,
    y2: -72.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87A7E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3227_19821",
    x1: 46.9062,
    y1: 20.0235,
    x2: 49.7904,
    y2: 20.0235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3227_19821",
    x1: 45.8047,
    y1: 23.3333,
    x2: 49.8082,
    y2: 23.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3227_19821",
    x1: 40.0548,
    y1: 22.9164,
    x2: 38.4857,
    y2: 22.3258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22973,
    stopColor: "#DE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862162,
    stopColor: "#DE873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3227_19821",
    x1: 28.2469,
    y1: 31.5869,
    x2: 31.5609,
    y2: 31.5869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206186,
    stopColor: "#232C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688144,
    stopColor: "#2F3842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3842"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3227_19821",
    x1: 30.5349,
    y1: 30.3,
    x2: 29.5167,
    y2: 28.5365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244845,
    stopColor: "#E03123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708763,
    stopColor: "#EF5146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3227_19821",
    x1: 28.5859,
    y1: 30.3609,
    x2: 31.4688,
    y2: 30.3609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131443,
    stopColor: "#BD0E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654703,
    stopColor: "#EC3326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739691,
    stopColor: "#EC3326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3227_19821",
    x1: 28.2469,
    y1: 34.13,
    x2: 31.5608,
    y2: 34.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206186,
    stopColor: "#232C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688144,
    stopColor: "#2F3842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3842"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLeftLogo);
export default __webpack_public_path__ + "static/media/HeaderLeftLogo.9924d4822404c31ae24c2a5e3d664dda.svg";
export { ForwardRef as ReactComponent };